// Agent panel:

// {{{ Office.QueueControlPanel

GW.define('Office.QueueControlPanel', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'queue-control-panel js-msgbus',
			children: [{
				ref: 'wrapEl',
				className: 'wrap',
				children: [{
					ref: 'listEl',
					className: 'queue-list',
					'on:click': ev => {
						let btn = ev.target.closest('.queue');
						if (btn) {
							ev.preventDefault();
							this.onQueueButtonClick(btn, ev);
						}
					},
				}, {
					ref: 'controlsEl',
					className: 'controls',
					children: [{
						ref: 'expanderButton',
						xtype: 'Widgets.ExpanderToggleButton',
					}, {
						ref: 'subMenu',
						nodeName: 'button',
						className: 'more transparent hidden',
						children: [Utils.useIcon('vdots')],
						'on:click': ev => {
							ev.preventDefault();
							this.onMoreButtonClick(ev);
						},
					}, {
						ref: 'pauseButton',
						nodeName: 'button',
						className: 'pause hidden',
						'on:click': ev => {
							ev.preventDefault();
							this.onPauseButtonClick(ev);
						},
					}, {
						ref: 'extenPauseButton',
						nodeNname: 'button',
						className: 'pause hidden',
						title: _('Prodloužit autopauzu'),
						children: [Utils.useIcon('clockplus')],
						'on:click': ev => {
							ev.preventDefault();
							this.onExtendPauseButtonClick(ev);
						},
					}],
				}],
			}],
		}, this);

		this.queuesExpander = Features.expandingListContainer({
			container: this.listEl,
			expanderButton: this.expanderButton,
			onExpanded: expanded => {
				this.el.classList.toggle('expanded', expanded);
			},
		});

		this.redrawQueues();
	},

	releaseComponent() {
		this.queuesExpander.destroy();
	},

	async onQueueButtonClick(btn, ev) {
		let extension = Application.session.user.extension;
		let queue = btn.$data;
		if (queue.static) {
			return;
		}

		if (queue.state == 'unsubscribed') {
			await Office.QueueManager.joinQueue(queue.queue, extension);
		} else {
			await Office.QueueManager.leaveQueue(queue.queue, extension);
		}

		this.queuesExpander.expanded = false;
	},
	
	async onPauseButtonClick(ev) {
		let extension = Application.session.user.extension;
		if (!extension) {
			return;
		}

		let pause = Office.QueueManager.active_pause;
		if (pause) {
			await Office.QueueManager.unpauseExtension(extension);
		} else {
			let types = Office.QueueManager.getPauseTypes();
			if (types.length > 0) {
				let popup = new PopupMenu({
					options: types.map(pause_type => ({
						text: pause_type.name,
						async handle() {
							await Office.QueueManager.pauseExtension(extension, pause_type.id);
						},
					})),
				});
				
				PopupManager.show(popup, {
					anchorEl: ev.target.closest('button'),
					forceAxis: 'vertical',
					preferReadingOrder: true,
				});
			} else {
				await Office.QueueManager.pauseExtension(extension);
			}
		}
	},
	
	async onExtendPauseButtonClick(ev) {
		let extension = Application.session.user.extension;

		await Office.QueueManager.extendExtensionPause(extension);
	},

	getQueueListConfig() {
		let defaults = {
			show_queue_numbers: true,
			show_queue_names: true,
			compact: false,
			sort: 'number',
			subscribed_first: false,
		};

		let conf = JSON.parse(localStorage.getItem('agent-queue-list-config'));
		if (typeof conf != 'object' || !conf) {
			return defaults;
		}

		conf = Object.assign(defaults, conf);

		if (!conf.compact) {
			conf.show_queue_numbers = conf.show_queue_names = true;
		} else if (conf.show_queue_numbers && conf.show_queue_names) {
			conf.show_queue_numbers = false;
		} else if (!conf.show_queue_names && !conf.show_queue_numbers) {
			conf.show_queue_names = true;
		}

		return conf;
	},

	saveQueueListConfig(conf) {
		localStorage.setItem('agent-queue-list-config', JSON.stringify(conf));
	},

	updateQueueListConfig(patch) {
		this.saveQueueListConfig(Object.assign(this.getQueueListConfig(), patch));

		this.redrawQueues();
	},

	onMoreButtonClick(ev) {
		let extension = Application.session.user.extension;
		let conf = this.getQueueListConfig();

		let popup = new PopupMenu({
			options: [{
				iconName: 'login',
				text: _('Přihlásit do všech front'),
				async handle() {
					await Office.QueueManager.joinAllQueues(extension);
				},
			}, {
				iconName: 'logout',
				text: _('Odhlásit ze všech front'),
				async handle() {
					await Office.QueueManager.leaveAllQueues(extension);
				},
			}, {
				hidden: !conf.compact,
				render: {
					className: 'option separator',
				}
			}, {
				hidden: !conf.compact,
				iconName: 'number',
				text: _('Zobrazit čísla front'),
				cls: conf.show_queue_numbers ? 'active' : undefined,
				rightIconName: conf.show_queue_numbers ? 'check' : null,
				handle: () => {
					this.updateQueueListConfig({
						show_queue_numbers: !conf.show_queue_numbers,
						show_queue_names: !!conf.show_queue_numbers,
					});
				},
			}, {
				hidden: !conf.compact,
				iconName: 'letter',
				text: _('Zobrazit názvy front'),
				cls: conf.show_queue_names ? 'active' : undefined,
				rightIconName: conf.show_queue_names ? 'check' : null,
				handle: () => {
					this.updateQueueListConfig({
						show_queue_names: !conf.show_queue_names,
						show_queue_numbers: !!conf.show_queue_names,
					});
				},
			}, {
				render: {
					className: 'option separator',
				}
			}, {
				iconName: 'sorting',
				text: _('Řadit podle čísla front'),
				cls: conf.sort == 'number' ? 'active' : undefined,
				rightIconName: conf.sort == 'number' ? 'check' : null,
				handle: () => {
					this.updateQueueListConfig({
						sort: 'number',
					});
				},
			}, {
				iconName: 'sorting',
				text: _('Řadit podle názvu front'),
				cls: conf.sort == 'name' ? 'active' : undefined,
				rightIconName: conf.sort == 'name' ? 'check' : null,
				handle: () => {
					this.updateQueueListConfig({
						sort: 'name',
					});
				},
			}, {
				render: {
					className: 'option separator',
				}
			}, {
				iconName: 'dashboard',
				text: _('Výrazné zobrazení front'),
				cls: !conf.compact ? 'active' : undefined,
				rightIconName: !conf.compact ? 'check' : null,
				handle: () => {
					this.updateQueueListConfig({
						compact: false,
					});
				},
			}, {
				iconName: 'hamburger',
				text: _('Kompaktní zobrazení front'),
				cls: conf.compact ? 'active' : undefined,
				rightIconName: conf.compact ? 'check' : null,
				handle: () => {
					this.updateQueueListConfig({
						compact: true,
					});
				},
			}, {
				render: {
					className: 'option separator',
				}
			}, {
				iconName: conf.subscribed_first ? 'checkbox-on' : 'checkbox-off',
				text: _('Zobrazovat přihlášené fronty jako první'),
				handle: () => {
					this.updateQueueListConfig({
						subscribed_first: !conf.subscribed_first,
					});
				},
			}],
		});

		PopupManager.show(popup, {
			anchorEl: ev.target,
			forceAxis: 'vertical',
			preferReadingOrder: true,
		});
	},
	
	updatePauseTimer() {
		let pause = Office.QueueManager.active_pause;

		if (!this.pauseTimer) {
			return;
		}

		if (!pause || !pause.start_ts) {
			this.pauseTimer.textContent = '';
			return;
		}

		const duration = pause.end_ts ? (pause.end_ts - Date.now()) : (Date.now() - pause.start_ts); 

		this.pauseTimer.textContent = Formats.duration_unpadded(Math.max(0, duration));
	},

	refreshPauseButton() {
		let pause = Office.QueueManager.active_pause;
		let is_subscribed = Office.QueueManager.getSubscribedQueues().length > 0;

		if (pause) {
			let is_wrapup = pause.end_ts && pause.type === 'wrapup';
			let pauseText = pause.pause_type ? (' (' + pause.pause_type.name + ')') : '';
			let actionText = {
				'wrapup': _('Zrušit autopauzu'),
				'autopause': _('Zrušit vynucenou pauzu'),
			}[pause.type] || _('Zrušit pauzu')

			this.pauseButton.gwReplaceChildren([{
				className: 'icon-wrap',
				children: [Utils.useIcon('play')],
			}, {
				className: 'info',
				children: [{
					className: 'text',
					children: [{
						nodeName: 'span',
						textContent: actionText,
					}, {
						nodeName: 'span',
						className: 'pause-type',
						':skip': !pause.pause_type,
						textContent: pauseText,
					}],
				}, {
					className: 'timer',
					ref: 'pauseTimer',
				}]
			}], this);

			this.extenPauseButton.classList.toggle('hidden', !is_wrapup);

			this.pauseButton.disabled = false;
			this.pauseButton.dataset.state = 'paused';
			this.pauseButton.$title = actionText + ' ' + pauseText;

			this.updatePauseTimer();
			Utils.interval(this, 'pause-timer-update', 1000, () => this.updatePauseTimer());
		} else {
			this.pauseButton.gwReplaceChildren([{
				className: 'icon-wrap',
				children: [Utils.useIcon('pause')],
			}, {
				className: 'info',
				children: [{
					className: 'text',
					textContent: _('Zapnout pauzu'),
				}, {
					className: 'timer',
					ref: 'pauseTimer',
				}]
			}]);

			this.extenPauseButton.classList.toggle('hidden', true);

			this.pauseButton.dataset.state = 'not-paused';
			this.pauseButton.disabled = !is_subscribed;
			this.pauseButton.$title = _('Zapnout pauzu');

			Utils.abortInterval(this, 'pause-timer-update');
		}

		let conf = this.getQueueListConfig();

		this.pauseButton.title = conf.compact ? this.pauseButton.$title || '' : '';
	},

	redrawQueues() {
		let conf = this.getQueueListConfig();
                let queues = Office.QueueManager.queues.slice();
		let extension = Application.session.user.extension;
		let showMenuAndPause = queues.length > 0 && extension;

		if (conf.sort == 'name') {
			queues.sort((a, b) => {
				let an = a.name || '';
				let bn = b.name || '';

				return an.localeCompare(bn);
			});
		}

		if (conf.subscribed_first) {
			queues.sort((a, b) => {
				let as = a.state == 'subscribed' ? 1 : 0;
				let bs = b.state == 'subscribed' ? 1 : 0;

				return bs - as;
			});
		}

		this.el.classList.toggle('compact', !!conf.compact);

		if (queues.length == 0) {
			this.pauseButton.gwHide(true);
			this.subMenu.gwHide(true);
			this.listEl.gwReplaceChildren([{
				className: 'empty panel-container',
				textContent: _('Žádné fronty nejsou dostupné'),
			}]);
			return;
		}

		this.pauseButton.gwHide(!showMenuAndPause);
		this.pauseButton.title = conf.compact ? this.pauseButton.$title || '' : '';
		this.refreshPauseButton();

		this.subMenu.gwHide(!showMenuAndPause);

		this.listEl.gwReplaceChildren(queues.map(q => {
			const info = q.info;
			return {
				$data: q,
				nodeName: 'button',
				className: 'queue' + ((!q.state || q.power_dialer_active === false) ? ' disabled' : ''),
				'attr:data-power-dialer-active': q.power_dialer_active === undefined ? undefined : (q.power_dialer_active ? '1' : '0'),
				'attr:data-status': q.state || 'unsubscribed', // unsubscribed subscribed paused
				'attr:data-static': q.static ? '1' : '0',
				'attr:data-type': q.type,
				children: [{
					className: 'status',
				}, {
					className: 'info',
					children: [{
						className: 'name',
						textContent: !conf.show_queue_names ? q.queue : q.name || q.queue,
						title: q.name || '',
					}, {
						':skip': !conf.show_queue_numbers || !q.name || !conf.show_queue_names,
						className: 'number',
						textContent: q.queue,
					}],
				}, {
					className: 'counts',
					children: info && [{
						':skip': info.free_agents_bad_max == null || info.free_agents_warn_max == null,
						className: 'free-agents button small static ' + 
							(info.free_agents_count <= info.free_agents_bad_max ? 'error' : 
								(info.free_agents_count <= info.free_agents_warn_max ? 'warning-secondary' : 'success-secondary')
							),
						textContent: info.free_agents_count,
						title: `${_('Volných agentů')} (${info.free_agents_count})`,
					}, {
						':skip': info.waiting_calls_warn_max == null || info.waiting_calls_ok_max == null,
						className: 'waiting-calls button small static ' +
							(info.waiting_calls_count <= info.waiting_calls_ok_max ? 'success-secondary' : 
								(info.waiting_calls_count <= info.waiting_calls_warn_max ? 'warning-secondary' : 'error')
							),
						textContent: info.waiting_calls_count,
						title: `${_('Čekajících hovorů')} (${info.waiting_calls_count})`,
					}]
				}],
			};
		}));

		this.queuesExpander.refresh();
	},

	onBusMessage(msg) {
		if (msg.type === 'QUEUE_MANAGER_QUEUES_LIST_CHANGE') {
			this.redrawQueues();
		}

		if (msg.type === 'QUEUE_MANAGER_PAUSE_TYPES_CHANGE') {
			if (this.pauseButton) {
				this.pauseButton.classList.toggle('with-pause-types', Office.QueueManager.getPauseTypes().length > 0);
			}
		}
	},
});

// }}}
// {{{ Office.AgentHistoryPanel

GW.define('Office.AgentHistoryPanel', 'Office.HistoryPanel', {
	
	'after:initComponent'() {
		// reload queues only if queue manager is not active. The queues may be not loaded or outdated in this cases.
		if (!Office.QueueManager.active) {
			Office.QueueManager.loadQueues(false);
		}
		
		if (!this.limitCallsToUserId()) {
			// subscribe to all CALL_ENDED events if the user can see other users call
			this.el.socketSubscriptions = [...(this.el.socketSubscriptions || []), 'call_updates']; 
		}
		
		this.callsTableColumnsSelector = Features.tableColumnsSelector({
			localStorageKey: 'queue-history-columns',
			getAllColumns: Office.CallsTable.prototype.getColumns,
			onSave: () => {
				const c = this.cards.getCards()[0];
				c && c.refresh && c.refresh();
			},
			defaultHidden: ['category1','category2','last_note'],
		});
	},
	
	renderToolbarButtons() {
		return [{
			nodeName: 'button',
			type: 'button',
			className: 'secondary small icon-only',
			children: [Utils.useIcon('settings')],
			'on:click': () => {
				this.callsTableColumnsSelector.showDialog();
			},
		}];
	},

	getTabs() {
		const queues = Office.QueueManager.queues;
		if (queues.length == 0) {
			return [];
		}
		return [{
			id: 'all',
			title: _('Všechny'),
			query: {
				conn_queue: queues.map(q => q.queue).join(','),
			},
		}, ...queues.map(v => {
			return {
				id: 'queue-' + v.queue,
				title: v.queue + (v.name ? ` - ${v.name}` : ''),
				query: {
					conn_queue: v.queue,
				},
			};
		})];
	},
	
	limitCallsToUserId() {
		// option 'queue_history_limited' affects only 'regular' and 'agent' member roles
		return Application.getActiveUserGroup().options.queue_history_limited &&
			['regular', 'agent'].includes(Application.getActiveUserGroup().member_role);
	},

	getApiQuery() {
		const query = {
			include_notes: 'only_last_one',
		}
		if (this.limitCallsToUserId()) {
			query.user_id = Application.session.user.id;
		}

		return query;
	},

	renderPhoneNumber(ct, number) {
		ct.textContent = number || '';
	},

	getListComponentConfig() {
		return {
			xtype: 'Office.CallsTable',
			// use wrap to use the original getColumns() which is dependent on the CallsTable instance
			// it's using renderPhoneNumber() to format cell
			'wrap:getColumns': fn => this.callsTableColumnsSelector.getSelectedColumns(fn()),
			renderPhoneNumber: this.renderPhoneNumber,
		};
	},

	getNoTabsConfig() {
		return {
			initComponent() {
				this.el = document.gwCreateElement({
					className: 'empty',
					textContent: _('Žádné fronty nejsou k dispozici'),
				});
			},
		}
	},

	'after:onBusMessage'(msg) {
		if (msg.type == 'QUEUE_MANAGER_QUEUES_LIST_CHANGE') {
			/*
			 * We need to update the list of queues (tabs)
			 */
			this.reload();
		}
	},

});

// }}}

// Call panel:

// {{{ Office.CallPanel

GW.define('Office.CallPanel', 'GW.Component', {

	autoOpenedCalls: new Set(),
	userInteractedCalls: new Set(),
	
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			children: [{
				ref: 'tabsEl',
				xtype: 'Widgets.ButtonSwitcher',
				cls: "button-switcher separate",
				renderItem: i => ({
					$data: i,
					'attr:data-item-id': i.id,
					nodeName: 'button',
					className: 'item',
					href: i.href || '#',
					children: [{
						nodeName: 'span',
						className: 'title',
						textContent: i.title,
					}, {
						':skip': i.preventClose || !i.onClose,
						nodeName: 'span',
						className: 'icon-wrapper',
						children: [Utils.useIcon('cross')],
						'on:click': ev => {
							ev.preventDefault();
							i.onClose();
						},
					}],
				}),
				'on:beforeselect': (c, i) => {
					this.selectCall(i.id);
				},
			}, {
				ref: 'cardSwitcher',
				xtype: 'Widgets.CardSwitcher',
			}],
		}, this);

		this.openCalls = this.loadCalls();
	},

	selectCall(id) {
		Application.route({
			paramsFn: params => {
				if (id === 'active') {
					// override 'active' with actual active call id
					let active_call = Office.CallManager.getActiveCall();
					if (active_call && this.openCalls.some(call => call.call_id == active_call.call_id)) {
						id = active_call.call_id;
					}
				}
				
				if (id === 'active' || !id) {
					params.delete('call_id');
				} else {
					params.set('call_id', id);
				}

				return params;
			},
		});
	},

	/*
	 * Open call list management. Open calls are calls the user loaded call
	 * card for.
	 */

	loadCalls() {
		let calls = localStorage.getItem('call-panel-cards-' + Application.session.user.id);
		let list = calls ? JSON.parse(calls) : [];

		/*
		 * We had a bug where we could have saved cards for calls without call_id,
		 * which causes problems. Remove these calls on load.
		 */
		list = list.filter(c => c.call_id);
		list = list.slice(0, 100); // ensure max ~100 calls can be open

		return list;
	},

	saveCalls() {
		localStorage.setItem('call-panel-cards-' + Application.session.user.id, JSON.stringify(this.openCalls));
	},

	addCall(call) {
		if (this.openCalls.some(c => c.call_id === call.call_id)) {
			return;
		}

		this.openCalls.unshift(call);
		this.saveCalls();
	},
	
	modifyCall(call_id, func) {
		let call = this.openCalls.find(c => c.call_id == call_id);
		if (call) {
			func(call);
			this.saveCalls();
		}
	},

	removeCall(call_id) {
		this.openCalls = this.openCalls.filter(c => c.call_id !== call_id);
		this.saveCalls();
	},

	openActiveCall(mode = 'user') {
		let call = Office.CallManager.getActiveCall();
		if (!call || !call.peer) {
			return;
		}

		this.addCall({
			call_id: call.call_id,
			phone: call.peer.number,
			queue: call.queue,
		});
		let select = mode == 'user';

		if (mode == 'auto' && Application.getActiveUserGroup().options.call_card_switch_to_on_open) {
			Application.dispatchMessage({type: 'SWITCH_TO_CALL_PANEL'});
			select = true;
		}
		
		if (!select && !(new URLSearchParams(location.search).has('call_id'))) {
			// call is not to be selected, but selected active card is 
			// the first one with active call -> force select this call id 
			// to update URI and refresh the UI 
			select = true;
		}

		if (select) {
			this.selectCall(call.call_id);
		} else {
			// do not refresh all UI, just the tabs to add close button in new call card
			this.refreshTabs();
		}
	},

	/*
	 * Show tabs such that the first tab selects either the no-call or
	 * ongoing call screens, or the actual call card, depending on:
	 *
	 * - active call status from call manager
	 * - whether the call is already in openCalls or not
	 *
	 * Rest of the buttons are for other already open call cards from the
	 * past. (based on this.openCalls which is persisted across page reloads)
	 */
	refreshTabs() {
		let dialer_call = Office.CallManager.getActiveCall();
		let is_active_call_open = dialer_call && this.openCalls.some(c => c.call_id == dialer_call.call_id);
		let tabs = [];
		
		let translatedCallStatus;
		switch(dialer_call && dialer_call.status) {
			case 'dialing': translatedCallStatus = _('Vytáčený hovor'); break;
			case 'incomming': translatedCallStatus = _('Příchozí hovor'); break;
			case 'hold': translatedCallStatus = _('Podržený hovor'); break;
			case 'connected': translatedCallStatus = _('Probíhající hovor'); break;
			default: translatedCallStatus = _('Žádný aktivní hovor');
		}

		tabs.push({
			id: 'active',
			call_id: dialer_call && dialer_call.call_id,
			title: translatedCallStatus,
			preventClose: !is_active_call_open,
			onClose: () => {
				this.removeCall(dialer_call.call_id);
				this.selectCall('active');
			},
		});

		let prev_tab = 'active';
		for (let c of this.openCalls.filter(c => !dialer_call || c.call_id != dialer_call.call_id)) {
			let next_sel = prev_tab;

			tabs.push({
				id: c.call_id,
				title: c.phone,
				onClose: () => {
					this.removeCall(c.call_id);
					this.selectCall(next_sel);
				},
			});

			prev_tab = c.call_id;
		}
		
		let sel = this.tabsEl.getSelected();
		this.tabsEl.setItems(tabs);
		this.tabsEl.setSelected(sel);
	},

	/*
	 * This handles initial loads, changes in active call state, and
	 * activations of a call cards by the user. Goal is to show a proper
	 * tab buttons, select a correct tab, and load a correct card to
	 * cardSwitcher.
	 */
	async applyParams(params) {
		let selected_tab = 'active';
		let dialer_call = Office.CallManager.getActiveCall();
		let open_call = params.get('call_id');
		let me = this;

		/*
		 * Without peer set, don't offer the call in call cards.
		 */
		if (dialer_call && !dialer_call.peer) {
			dialer_call = null;
		}

		if (dialer_call) {
			// keep call status in the openCalls list
			this.modifyCall(dialer_call.call_id, call => call.status = dialer_call.status);
		} else {
			if (Application.getActiveUserGroup().options.call_card_close_on_end) {
				// remove auto opened call cards which user has not interacted with
				this.openCalls.forEach(call => {
					if (this.autoOpenedCalls.has(call.call_id) && !this.userInteractedCalls.has(call.call_id)) {
						// delete = allow auto reopening if the same call appears again (like repeated queue call)
						this.autoOpenedCalls.delete(call.call_id);
						this.userInteractedCalls.delete(call.call_id);

						this.removeCall(call.call_id);

						Performance.pushEvent({
							kind: 'call-card-auto-close',
							call_id: call.call_id,
						});
					}
				})
			}
		}

		this.refreshTabs();

		let call = this.openCalls.find(c => c.call_id == open_call);
		if (call) {
			let card = await this.cardSwitcher.show({
				id: call.call_id,
				xtype: 'Office.CallPanel.CallCard',
				call,
				'on*:change'() {
					me.userInteractedCalls.add(call.call_id);
				},
				'on:close'() {
					me.userInteractedCalls.add(call.call_id);
					me.tabsEl.getItems().filter(i => (i.call_id || i.id) == call.call_id).forEach(i => i.onClose());
				},
			});

			if (!dialer_call || call.call_id != dialer_call.call_id) {
				selected_tab = call.call_id;
			}

			if (dialer_call) {
				card.updateCallData(dialer_call);
			}
		} else if (dialer_call && ['dialing', 'incomming', 'hold', 'connected'].includes(dialer_call.status)) {
			this.cardSwitcher.show({
				id: `incoming-${dialer_call.status}`,
				xtype: 'Office.CallPanel.CallIncomming',
				callstatus: dialer_call.status,
				'on:loadrequested': c => this.openActiveCall('user'),
			});
		} else {
			this.cardSwitcher.show({
				id: 'no-call',
				xtype: 'Office.CallPanel.NoCall',
			});
		}

		this.tabsEl.setSelected(selected_tab);

		// cleanup closed cards
		for (let c of this.cardSwitcher.getCards()) {
			if (c instanceof Office.CallPanel.CallCard) {
				let call_is_open = this.openCalls.some(call => call.call_id == c.call.call_id);
				if (!call_is_open) {
					c.destroy();
				}
			}
		}

		if (dialer_call &&
			Application.getActiveUserGroup().options.call_card_open_on_ring &&
			(dialer_call.status == 'incomming' || dialer_call.status == 'dialing') &&
			!this.autoOpenedCalls.has(dialer_call.call_id) &&
			!this.userInteractedCalls.has(dialer_call.call_id) // do not auto opened if user interacted with the call card
		) {
			this.autoOpenedCalls.add(dialer_call.call_id);
			this.openActiveCall('auto');

			Performance.pushEvent({
				kind: 'call-card-auto-open',
				call_id: dialer_call.call_id,
			});
		}
	},
	
	onBusMessage(msg) {
		if (msg.type === 'CALL_MANAGER_CHANGE') {
			this.applyParams(new URLSearchParams(location.search));
		}

		if (msg.type == 'CALL_ENDED') {
			// delay auto removing - do not remove before DIALER_CHANGED event
			setTimeout(() => {
				this.autoOpenedCalls.delete(msg.call_id);
				this.userInteractedCalls.delete(msg.call_id);
			}, 1000);
		}
	},
});

// }}}
// {{{ Office.CallPanel.CategorySelector

GW.define('Office.CallPanel.CategorySelector', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'call-category-selector',
			children: [{
				ref: 'cat1',
				xtype: 'SelectField',
				filterable: true,
				placeholder: _('Vyberte kategorii'),
				label: _('Hlavní kategorie'),
				getOptions: () => this.getCategoryOptions(null),
				transformOption(o) {
					return {
						value: o.id,
						text: o.name,
						cat: o,
					};
				},
				'on:change': c => {
					this.refreshCategories();
					this.cat2.setValue(null);
					this.fire('change');
				},
			}, {
				ref: 'cat2',
				xtype: 'SelectField',
				filterable: true,
				placeholder: _('Vyberte podkategorii'),
				label: _('Podkategorie'),
				optional: true,
				transformOption(o) {
					return {
						value: o.id,
						text: o.name,
						cat: o,
					};
				},
				getOptions: () => this.cat1.getValue() ? this.getCategoryOptions(this.cat1.getValue()) : [],
				'on:change': c => {
					this.fire('change');
				},
			}],
		}, this);

		this.setCategoryList([]);
	},

	setVisible(v) {
		this.el.gwHide(!v);
	},

	getCategoryOptions(parent) {
		let cats = this.categories.filter(c => c.parent == parent).map(c => {
			return {
				value: c.id,
				text: c.name,
				cat: c,
			};
		});

		cats.unshift({
			value: null,
			text: '-----',
		});

		return cats;
	},

	refreshCategories() {
		let l1_val = this.cat1.getValue();
		let l2_empty = !l1_val || this.getCategoryOptions(l1_val).length == 0;

		this.cat2.setDisabled(l2_empty); 
	},

	setCategoryList(cats) {
		this.categories = cats || [];

		this.refreshCategories();
		this.setVisible(this.categories.length > 0);
	},

	getSelectedCategories() {
		let o1 = this.cat1.getSelectedOption();
		let o2 = this.cat2.getSelectedOption();

		if (o1 && o1.cat) {
			if (o2 && o2.cat) {
				return [o1 && o1.cat, o2 && o2.cat];
			}

			return [o1 && o1.cat];
		}

		return null;
	},

	getValue() {
		return this.cat2.getValue() || this.cat1.getValue();
	},

	setValue(cats) {
		if (cats == null || cats.length == 0) {
			this.cat1.setValue();
			this.refreshCategories();
			return;
		}

		if (cats[0]) {
			this.cat1.setValue(cats[0]);
		}

		if (cats[1]) {
			this.cat2.setValue(cats[1]);
			this.cat2.setDisabled(false); 
		} else {
			this.refreshCategories();
		}
	},
});

// }}}
// {{{ Office.CallPanel.NoCall

GW.define('Office.CallPanel.NoCall', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'incomming-container',
			children: [{
				className: 'title text-muted',
				textContent: _('Žádný aktivní hovor'),
			}],
		});
	},
});

// }}}
// {{{ Office.CallPanel.CallIncomming

GW.define('Office.CallPanel.CallIncomming', 'GW.Component', {
	initComponent() {
		let translatedCallStatus;
		switch(this.callstatus) {
			case 'dialing': translatedCallStatus = _('Vytáčíte nový hovor'); break;
			case 'incomming': translatedCallStatus = _('Máte příchozí hovor'); break; 
			case 'hold': translatedCallStatus = _('Máte podržený hovor'); break; 
			case 'connected': translatedCallStatus = _('Máte probíhající hovor'); break; 
			default: translatedCallStatus = '';
		}
		
		this.el = document.gwCreateElement({
			children: [{
				className: 'incomming-container',
				children: [{
					className: 'title',
					textContent: translatedCallStatus,
				}, {
					nodeName: 'button',
					className: 'primary',
					textContent: _('Načíst kartu hovoru'),
					'on:click': () => {
						this.fire('loadrequested');
					},
				}],
			}]
		}, this);
	},
});

// }}}
// {{{ Office.CallPanel.PhoneNumberHistory

GW.define('Office.CallPanel.PhoneNumberHistory', 'GW.Component', {
	
	extension: null,
	limit: 1000,
	
	loadedParams: null,
	
	initComponent() {
		this.el = document.gwCreateElement({
			children: [{
				ref: 'toolbarEl',
				className: 'phone-history-toolbar',
				children: [{
					xtype: 'BinarySwitchField',
					text: _('Zobrazit jen poznámky'),
					'on:change': c => {
						Utils.setLocalState({key: 'call-card-notes-only'}, c.getValue());
						this.showItems();
					},
					value: Utils.getLocalState({key: 'call-card-notes-only'}),
				}, {
					ref: 'searchEl',
					className: 'search',
					xtype: 'TextField',
					type: 'search',
					extraClass: 'small',
					placeholder: _('Vyhledat...'),
					'on:change': el => {
						Utils.timer(this, 'search', 100, () => this.reloadData());
					}
				}],
			}, {
				ref: 'historyItems',
				className: 'history-items',
				'on*:click': ev => {
					if (ev.target.closest('.expander')) {
						ev.target.closest('.history-item-content').classList.toggle('expanded');
					}
				}
			}],
		}, this);
	},
	
	async reloadData() {
		const signal = Utils.abortAndRetry(this, 'reload-timeline');
		
		const params = {
			extension: this.phone,
			limit: this.limit,
			fulltext: this.searchEl.getValue(),
		}
		
		if (JSON.stringify(this.loadedCallsParams) != JSON.stringify(params)) {
			this.showLoading();
		}
		
		let calls = await REST.GET('calls', {
			...params,
			include_notes: true,
		}, {signal});
		this.setData(calls, params.phone);
		this.loadedCallsParams = params;
	},

	getNoteExpandState() {
		return new Set(Array.from(this.el.querySelectorAll('.history-item-content.expanded'))
			.map(el => el.$data.id));
	},

	setNoteExpandState(state) {
		for (let el of this.el.querySelectorAll('.history-item-content')) {
			el.classList.toggle('expanded', state.has(el.$data.id));
		}
	},

	renderItem(call, exclude_number) {
		let route = [{
			number: call.number,
			name: call.queue_name,
		}, call.caller, call.callee];

		if (call.callee.number != call.last_callee.number) {
			route.push(call.last_callee);
		}

		route = route.filter(r => r && r.number && !phone_number_equal(r.number, exclude_number));

		let detail = route.map(r => {
			return [r.number, r.name, r.company].filter(v => v).join(' ');
		}).join(' - ');

		let time = Formats.date(call.start) + ', ' + Formats.time(call.start);
		if (call.duration) {
			time += ', ' + Formats.duration(call.duration);
		}

		let category = null;
		if (call.call_category && call.call_category.length > 0) {
			let hierarchy = call.call_category_hierarchy;

			category = {
				className: 'history-item-call-categories',
				children: [_('Kategorie'), {
					className: 'hierarchy',
					textContent: " - " + hierarchy.name,
				}, ...call.call_category.map(c => {
					return {
						className: 'category',
						textContent: c.name,
					};
				})],
			};
		}

		return {
			className: 'history-item',
			children: [{
				className: 'history-item-header',
				children: [{
					className: 'history-item-header-icon',
					children: [Office.renderDirectionIcon(call)],
				}, {
					className: 'history-item-header-info',
					children: [{
						className: 'history-item-header-datetime',
						textContent: time,
					}, {
						':skip': !detail,
						className: 'history-item-header-detail',
						textContent: detail,
					// PLUGIN EXTENSION POINT
					}, ...this.renderPluginButtons(call)],
				}],
			}, category, {
				$data: call,
				className: 'history-item-content',
				children: call.notes.map(n => this.renderCallNote(n)).concat([{
					':skip': call.notes.length <= 1,
					className: 'expander',
					children: [{
						textContent: _('Více'),
						className: 'label expand',
					}, {
						textContent: _('Méně'),
						className: 'label collapse',
					}],
				}]),
			}],
		};
	},

	renderPluginButtons() {
		return [];
	},

	renderCallNote(note) {
		return {
			className: 'call-info-agent-note-box',
			children: [{
				className: 'header',
				children: [{
					className: 'user',
					textContent: note.user_name + ' - ' + note.user_extension,
				}, {
					className: 'time',
					textContent: Formats.datetime(note.ts),
				}],
			}, {
				className: 'content',
				textContent: note.note,
			}],
		};
	},

	showLoading() {
		this.toolbarEl.gwHide();
		this.historyItems.gwReplaceChildren([{
			className: 'empty',
			textContent: _('Data se načítají...'),
		}]);
	},
	
	showItems() {
		let state = this.getNoteExpandState();
		const calls = this.calls;
		
		if (!calls) {
			this.toolbarEl.gwHide();
			this.historyItems.gwReplaceChildren([{
				className: 'empty',
				textContent: _('Číslo nemá historii'),
			}]);
		} else {
			this.toolbarEl.gwHide(false);

			const notesOnly = Utils.getLocalState({key: 'call-card-notes-only'}, false);
			if (notesOnly) {
				this.historyItems.gwReplaceChildren(calls.flatMap(call => call.notes.map(note => this.renderCallNote(note))));
			} else {
				this.historyItems.gwReplaceChildren(calls.map(c => this.renderItem(c, this.exclude_number)));
			}
		}

		this.setNoteExpandState(state);
	},

	setData(calls, exclude_number) {
		this.calls = calls;
		this.exclude_number = exclude_number;
		this.showItems();
	},

	async applyParams() {
		await this.reloadData();
	},
	
});

// }}}
// {{{ Office.CallPanel.CallCard

GW.define('Office.CallPanel.CallCard', 'GW.Component', {
	call: null,
	showCategory: true,
	showRightPane: true,
	
	data: null,
	
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			children: [{
				ref: 'contactEl',
				className: 'contact-container',
			}, {
				className: 'content-container',
				children: [{
					ref: 'noteContainer',
					className: 'note-container',
					children: this.renderLeftPane(),
				}, {
					':skip': !this.showRightPane,
					ref: 'rightPaneEl',
					className: 'right-pane-container',
					children: [{
						ref: 'rightPaneTabsEl',
						xtype: 'Widgets.ButtonSwitcher',
						cls: "button-switcher small",
						'on:beforeselect': (c, i) => {
							this.showRightPaneTab(i.id);
						},
					}, {
						ref: 'rightPaneTitle',
						className: 'call-card-title',
					}, {
						ref: 'rightPaneCardsEl',
						xtype: 'Widgets.CardSwitcher',
					}],
				}],
			}]
		}, this);

		Features.horizontalSplitResizerMixin({
			storageKey: 'note-container-ratio',
			leftEl: this.noteContainer,
			lifetimeComponent: this,
		});

		if (this.showRightPane) {
			let tabs = this.getRightPaneTabs().filter(t => t);
			if (tabs.length > 0) {
				if (tabs.length == 1) {
					// show only one card, with title, hide tabs
					this.rightPaneTitle.textContent = tabs[0].title;
					this.rightPaneTabsEl.el.classList.add('hidden');
				} else {
					this.rightPaneTitle.remove();
				}
				this.rightPaneTabsEl.setItems(tabs);
				this.showRightPaneTab(tabs[0].id);
			}
		}

		this.reloadOnActivate = true;
		this.firstLoadDone = false;
	},

	renderLeftPane() {
		let details = this.renderCallDetails();
		if (details.length > 0) {
			details.unshift({
				className: 'call-card-title',
				textContent: _('Detaily hovoru'),
			});
		}

		return [
			...details,
			...this.renderCategorySelector(),
			...this.renderCallNotes(),
		];
	},

	/*
	 * PLUGIN: extension point
	 */
	renderCallDetails() {
		return [];
	},

	renderCategorySelector() {
		return [{
			':skip': !this.showCategory,
			ref: 'categoryHierarchyNameEl',
			className: 'call-card-title hidden',
		}, {
			':skip': !this.showCategory,
			ref: 'categorySelector',
			xtype: 'Office.CallPanel.CategorySelector',
			'on:change': async c => {
				await REST.PUT('call-info/' + encodeURIComponent(this.call.call_id), {
					category: c.getValue(),
				});
			},
		}];
	},

	renderCallNotes() {
		return [{
			ref: 'notesTitleEl',
			className: 'call-card-title',
			textContent: _('Poznámky k hovoru'),
		}, {
			nodeName: 'label',
			textContent: _('Nová poznámka'),
		}, {
			ref: 'noteField',
			xtype: 'TextareaField',
			$key_Ctrl_Enter: () => {
				this.onSaveNote().then(() => {
					this.fire('close');
				});
			},
		}, {
			// PLUGIN: extension point for
			// adding more buttons
			ref: 'callNoteButtons',
			className: 'buttons',
			children: [{
				ref: 'sendButton',
				nodeName: 'button',
				type: 'button',
				className: 'primary',
				textContent: _('Uložit a zavřít kartu hovoru'),
				'on:click': ev => {
					this.onSaveNote().then(() => {
						this.fire('close');
					});
				},
			}],
		}, {
			ref: 'callNotesEl',
			className: 'note-list',
			'attr:text-no-entry': _('Tento hovor je bez poznámek'),
		}];
	},
	
	/*
	 * PLUGIN: extension point for plugins
	 */
	getRightPaneTabs() {
		return [{
			id: 'phone-history',
			title:  _('Historie čísla'),
			card: this.renderPhoneHistory(),
		}];
	},
	
	showRightPaneTab(id) {
		this.rightPaneTabsEl.setSelected(id);
		let tabs = this.rightPaneTabsEl.getItems();
		let tab = tabs.find(t => t.id == id);
		this.rightPaneCardsEl.show({
			id,
			...tab.card,
		});
	},
	
	renderPhoneHistory() {
		return {
			xtype: 'Office.CallPanel.PhoneNumberHistory',
			phone: this.call.phone,
			limit: 100,
		};
	},

	async onSaveNote() {
		const note = this.noteField.getValue();
		if (!note) {
			return false;
		}

		try {
			this.noteField.setDisabled(true);
			this.sendButton.disabled = true;

			await REST.POST('call-info/' + this.call.call_id + '/notes', {note});

			this.noteField.setValue('');
			this.afterNoteSaved();
			return true;
		} finally {
			this.noteField.setDisabled(false);
			this.sendButton.disabled = false;
		}

		return false;
	},

	afterNoteSaved() {
		
	},

	renderCallNote: Office.CallPanel.PhoneNumberHistory.prototype.renderCallNote,

	async updateEditContactButton(contact) {
		const signal = Utils.abortAndRetry(this, 'contact-groups');
		const [groups] = await Utils.cache(this, 'contact-groups', 10000, REST.GET, 'contact-groups', null, {signal});

		const editableGroups = groups.filter(g => g.editable);
		if (!editableGroups.length) {
			return;
		}
		
		const phone = this.call.phone;
		
		if (await Office.InternalNumbers.isInternal(phone)) {
			// internal number do not need to be added in contacts
			return;
		}

		let contact_data = {
			phones: [phone],
		};
		if (contact) {
			if (contact.group_id) {
				// the contact has been just created, assume we have all fields set
				contact_data = contact;
			} else {
				contact_data = await REST.GET('contacts/' + contact.contact_id);
			}
			if (!editableGroups.some(g => g.group_id = contact_data.group_id)) {
				// the contact group is not editable = contact is not editable
				return;
			}
		}

		this.editContactBtn.onclick = async () => {
			new Office.ContactEditDialog({
				contactGroups: editableGroups,
				showDeleteButton: false,
				disabledFields: ['phone0', 'phone1'],
				title: contact ? _('Úprava kontaktu') : _('Nový kontakt'),
				contact: contact ? contact_data : {
					// if contact set, use its loaded data, else fill the only known data = phone
					phones: [phone],
				},
				'on:aftersave': (c,d) => this.setDataContact({...contact, ...d, contact_id: d.id})
			});
		}
		this.editContactBtn.classList.remove('hidden');
	},
	
	setDataContact(contact) {
		if (contact === undefined) {
			this.contactEl.gwHide(true);
			return;
		}
		this.contactEl.gwHide(false);
		if (contact) {
			this.contactEl.gwReplaceChildren([Utils.useIcon('user'), {
				textContent: [contact.name, contact.company].filter(v => v).join(', ')
			}, {
				nodeName: 'button',
				ref: 'editContactBtn',
				title: _('Upravit kontakt'),
				className: 'small secondary icon-only hidden',
				children: [Utils.useIcon('edit')],
			}], this);
		} else {
			this.contactEl.gwReplaceChildren([{
				textContent: _('Kontakt není uložen v adresáři')
			}, {
				nodeName: 'button',
				ref: 'editContactBtn',
				title: _('Přidat do adresáře'),
				className: 'small secondary icon-only hidden',
				children: [Utils.useIcon('plus')],
			}], this);
		}
		this.updateEditContactButton(contact);
	},

	setData(data) {
		let {contact} = data;
		
		this.setDataContact(contact);

		if (data.call_notes.length > 0) {
			this.callNotesEl.gwReplaceChildren(data.call_notes.map(n => this.renderCallNote(n)));
		} else {
			this.callNotesEl.gwReplaceChildren([]);
		}

		if (this.showCategory) {
			this.categorySelector.setValue(data.call_category || []);
		}

		this.data = data;
	},

	/*
	 * In some situations we may receive queue information later on during
	 * the call. We need to update the UI with category info for that queue.
	 */
	async updateCallData(call) {
		if (this.call.queue || !call.queue) {
			return;
		}

		this.call.queue = call.queue;
		this.onQueueUpdated();
	},

	/*
	 * PLUGIN: extension point for loading more data
	 */
	async onQueueUpdated() {
		await this.reloadCategorySelector();
	},

	async reloadCategorySelector() {
		let signal = Utils.abortAndRetry(this, 'reload');
		
		if (this.showCategory && this.call.queue) {
			let hierarchy = await Office.QueueManager.getCategoryHierarchy(this.call.queue, {signal});

			this.categorySelector.setCategoryList(hierarchy ? hierarchy.categories : []);

			this.categoryHierarchyNameEl.gwHide(!hierarchy);
			this.categoryHierarchyNameEl.textContent = hierarchy ? _('Kategorie') + ' \u2014 ' + hierarchy.name : '';
			this.notesTitleEl.gwHide(!hierarchy);
		} else {
			this.notesTitleEl.gwHide(true);
		}
	},

	/*
	 * PLUGIN: extension point for loading more data
	 */
	async reload() {
		await this.reloadCategorySelector();
		await this.reloadCallInfo();
	},

	/*
	 * PLUGIN: extension point for loading more data
	 */
	async reloadCallInfo() {
		let signal = Utils.abortAndRetry(this, 'reload-call-info');

		let data = await REST.GET('call-info/' + encodeURIComponent(this.call.call_id), {phone: this.call.phone}, {signal});

		this.setData(data);
	},

	isCallRelated(call_id) {
		return this.call.call_id == call_id ||
			this.data.call_notes.some(n => n.call_id == call_id);
	},

	async applyParams() {
		if (this.reloadOnActivate) {
			this.reloadOnActivate = false;

			await this.reload();

			if (!this.firstLoadDone && this.call.queue) {
				this.firstLoadDone = true;

				await this.onQueueUpdated();
			}
		}
	},

	onBusMessage(msg) {
		if (msg.type === 'CDR_NOTE_ADDED' || msg.type === 'CALL_INFO_CHANGED') {
			if (this.isCallRelated(msg.call_id)) {
				if (this.el.offsetWidth) {
					this.reloadCallInfo();
				} else {
					this.reloadOnActivate = true;
				}
			}
		}
	},
});

// }}}

// Outbound:

// {{{ Office.AgentOutboundPanel

GW.define('Office.AgentOutboundPanel', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus column-panel',
			children: [{
				className: 'toolbar',
				children: [{
					className: "toolbar-top",
					children: [{
						ref: 'tabs',
						xtype: 'Widgets.ButtonSwitcher',
						autofocusActive: true,
						cls: "button-switcher small campaign-switcher",
						'on:beforeselect': (c, i) => {
							Application.route({
								paramsFn: params => {
									params.set('campaign', i.id);
									return params;
								},
							});
						},
					}, {
						ref: 'filter',
						xtype: 'SelectField',
						popupAutoWidth: false,
						cls: 'small',
						options: [{
							id: 'new',
							value: 'new',
							text: _('Nezahájené'),
							query: {
								status: 'new',
								limit_time: true,
								limit: 200,
							},
						}, {
							id: 'mine',
							value: 'mine',
							text: _('Moje případy'),
							query: {
								status: 'mine',
								limit_time: true,
								limit: 200,
							},
						}, {
							id: 'all',
							value: 'all',
							text: _('Všechny případy'),
							query: {
								status: 'not-closed',
								limit_time: false,
								limit: 200,
							},
						}],
						'on:change': c => {
							Application.route({
								paramsFn: params => {
									params.set('campaign_filter', c.getValue());
									return params;
								},
							});
						},
					}, {
						ref: 'descriptionButton',
						type: 'button',
						nodeName: 'button',
						className: 'secondary icon-left small show-description-button',
						children: [Utils.useIcon('report'), _('Popis kampaně') ],
						'on:click': () => {
							let description = this.description;
							new Main.Dialog({
								title: _('Popis kampaně'),

								'after:initComponent'() {
									this.bodyEl.gwCreateChild({
										textContent: description
									});
								},
							});
						},
					}],
				}],
			}, {
				ref: 'cards',
				xtype: 'Widgets.CardSwitcher',
			}],
		}, this);

		Utils.interval(this, 'timer-update', 60000 + Math.random() * 20000, () => this.timedRefresh());
	},

	renderPhoneNumber(ct, number) {
		ct.textContent = number || '';
	},

	getListComponentConfig() {
		let me = this;

		return {
			xtype: 'SmartTable',
			monitorOverflow: true,
			extraClass: 'outbound-cases-smart-table js-msgbus',
			getColumns() {
				return [{
					id: 'contact_name',
					name: _('Jméno'),
					formatCell(td, v, row) {
						td.textContent = row.contact_name || row.contact_company ? v : row.contact_name_linked;
					},
				}, {
					id: 'contact_company',
					name: _('Firma'),
					formatCell(td, v, row) {
						td.textContent = row.contact_name || row.contact_company ? v : row.contact_company_linked;
					},
				}, {
					id: 'contact_phone',
					name: _('Telefon'),
					formatCell: me.renderPhoneNumber,
				}, {
					id: 'contact_note',
					name: _('Poznámka'),
					formatCell(td, v, row) {
						v = (v || '').trim();

						td.textContent = v.replace(/\r?\n/g, ' ⏎ ');
						td.title = v;
					},
				}, {
					id: 'status',
					name: _('Stav'),
					format: 'campaign_case_status',
				}, {
					id: 'activated',
					name: _('Čas zahájení'),
					format: 'datetime',
				}, {
					id: 'last_agent_name',
					name: _('Vyřizuje'),
				}, {
					id: 'last_agent_exten',
					name: _('Linka'),
					formatCell: me.renderPhoneNumber,
				}, {
					id: 'attempts',
					name: _('Pokusů'),
				}, {
					id: 'last_contact',
					name: _('Čas posledního volání'),
					format: 'datetime',
				}, {
					id: 'time_slots',
					name: _('Časový slot'),
					formatCell(td, v, row) {
						/* let's keep it just here for
						 * now, because this is just
						 * a quirky API.
						 */
						function formatTime(t) {
							if (t == null || t === '') {
								return '';
							}

							let h = Math.floor(t / 60 / 60);
							let m = Math.floor(Math.floor(t / 60) % 60);

							return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0');
						}

						let start = formatTime(row.contact_time_range_start);
						let end = formatTime(row.contact_time_range_end);

						if (start || end) {
							td.textContent = `${start} - ${end}`;
						}
					},
				}, {
					id: 'ctl',
					name: _('Akce'),
					formatCell(td, v, row) {
						td.gwCreateChild({
							nodeName: 'button',
							className: 'success icon-only small',
							'attr:data-action': 'dial',
							title: _('Vytočit'),
							'on:click': ev => {
								me.onDial(row);
							},
						});

						if (row.url != null && !String(row.url).match(/^[a-z0-9.+-]{1,30}:/i)) {
							row.url = null;
						}

						td.gwCreateChild({
							nodeName: 'a',
							className: 'outbound-case-openurl icon-only small button secondary' + (!row.url ? ' vhidden' : ''),
							href: row.url,
							target: '_blank',
							title: row.url && (_('Otevřít') + ' ' + row.url),
						});

						td.gwCreateChild({
							nodeName: 'button',
							className: 'secondary icon-only small' + (row.has_notes ? ' filled' : ''),
							'attr:data-action': 'outbound-case-notes',
							title: _('Poznámky'),
							'on:click': ev => {
								ev.preventDefault();
								me.showNotesDialog(row);
							},
						});

						td.gwCreateChild({
							nodeName: 'button',
							className: 'icon-only small ' + (row.close_result == 'success' ? 'primary selected' : 'secondary'),
							'attr:data-action': 'outbound-case-close',
							title: _('Uzavřít - úspěšné'),
							'on:click': ev => {
								ev.preventDefault();
								me.closeCase(row, 'success');
							},
						});

						td.gwCreateChild({
							nodeName: 'button',
							className: 'icon-only small ' + (row.close_result == 'fail' ? 'primary error selected' : 'secondary'),
							'attr:data-action': 'outbound-case-close-fail',
							title: _('Uzavřít - neuspěšné'),
							'on:click': ev => {
								ev.preventDefault();
								me.closeCase(row, 'fail');
							},
						});
					},
				}];
			},

			renderRow(tr, row) {
				tr.dataset.status = row.status || '';
				tr.dataset.mine = row.last_agent_user_id == Application.session.user.id ? '1' : '0';
				tr.classList.toggle('linked-contact', !(row.contact_name || row.contact_company)
					&& !!(row.contact_company_linked || row.contact_name_linked));
			},

			refreshControls() {
				for (let btn of this.el.querySelectorAll('button[data-action]')) {
					let action = btn.dataset.action;
					switch (action) {
					case 'outbound-case-notes':
						btn.disabled = false;
						break;
					case 'outbound-case-close':
					case 'outbound-case-close-fail':
						btn.disabled = false; //XXX: disable when other agent is working on this case
						break;
					default:
						btn.disabled = !Office.CallManager.canDo(action);
						break;
					}
				}
			},

			onBusMessage(msg) {
				if (msg.type == 'CALL_MANAGER_CHANGE') {
					this.refreshControls();
				}
			},

			'after:setData'() {
				this.refreshControls();
			},
		};
	},

	async closeCase(data, close_result) {
		await REST.POST('outbound/cases/' + encodeURIComponent(data.id) + '/close', {close_result});
		this.reload();
	},

	showNotesDialog(data) {
		new Main.NotesDialog({
			onSave(text) {
				return REST.POST('outbound/cases/' + encodeURIComponent(data.id) + '/comments', {
					text,
				});
			},

			loadData(signal) {
				return REST.GET('outbound/cases/' + encodeURIComponent(data.id) + '/comments', null, {signal});
			},
		});
	},

	async onDial(data) {
		await REST.POST('outbound/cases/' + encodeURIComponent(data.id) + '/activate');
		this.reload();

		let number = data.contact_phone;
		let campaign = this.tabs.getSelectedItemData();
		if (campaign && campaign.campaign && campaign.campaign.prefix_queue) {
			number = await Office.QueueManager.makeQueueAssignmentNumber(campaign.campaign.prefix_queue.queue, number);
		}

		Office.CallManager.doAction({action: 'dial', number, send_metadata: {outbound_case: data.id}});
	},

	reload() {
		Utils.clearCache(this);
		this.applyParams(new URLSearchParams(location.search));
	},

	getSelectedCampaign() {
		let tab = this.tabs.getSelectedItemData();

		return tab ? tab.campaign.id : null;
	},

	async applyParams(params) {
		let signal = Utils.abortAndRetry(this, 'reload');
		let [campaigns, campaignsChanged] = await Utils.cache(this, 'campaigns', 60000, REST.GET, 'outbound/campaigns', {
			status: 'active',
		}, {signal});

		let tabs = campaigns.map(c => {
			return {
				id: 'campaign-' + c.id,
				title: c.name,
				campaign: c,
			};
		});

		if (campaignsChanged) {
			this.tabs.setItems(tabs);
		}

		this.el.classList.toggle('no-campaign', tabs.length == 0);

		if (tabs.length == 0) {
			this.description = '';
			this.cards.show({
				id: 'no-campaign',
				initComponent() {
					this.el = document.gwCreateElement({
						className: 'empty',
						textContent: _('Žádné kampaně nejsou aktivní'),
					});
				},
			});
			return;
		}

		let tabId = params.get('campaign');
		let tab = tabs.find(t => t.id == tabId);
		if (!tab) {
			tab = tabs[0];
		}

		let filterId = params.get('campaign_filter');
		let filter = this.filter.options.find(i => i.id == filterId) || this.filter.options[0];
		this.filter.setValue(filter.id)

		this.description = tab.campaign.description || '';

		const tabSelected = this.tabs.getSelectedItemData();
		if (!tabSelected || (tabSelected && tabSelected.id !== tab.id)) {
			this.descriptionButton.disabled = !this.description;
		}

		let campaign_changed = this.getSelectedCampaign() != tab.campaign.id;
		this.tabs.setSelected(tab.id);

		let c = await this.cards.show({
			id: 'campaign',
			...this.getListComponentConfig(),
		});

		let extension = Application.session.user.extension;
		if (extension == null) {
			c.setData([]);
			return;
		}

		let [cases, casesChanged] = await Utils.cache(this, 'cases-' + tab.campaign.id, 60000,
			REST.GET, 'outbound/campaigns/' + tab.campaign.id + '/cases', {
			...filter.query,
		}, {signal});

		if (casesChanged || campaign_changed) {
			c.setData(cases);
		}
	},

	timedRefresh() {
		/*
		 * We only refresh if the tab is active. We don't clear the
		 * cache on purpose so that we effectively skip timed reload when
		 * websocket triggered update (which clears the cache) came in
		 * the last minute or so.
		 */
		if (this.el.offsetWidth) {
			this.applyParams(new URLSearchParams(location.search));
		}
	},

	onBusMessage(msg) {
		if (msg.type == 'OUTBOUND_CAMPAIGN_CHANGED') {
			this.reload();
		}

		let current_campaign_id = this.getSelectedCampaign();
		if (!current_campaign_id) {
			Utils.clearCache(this);
			return;
		}

		if (msg.type == 'OUTBOUND_CASE_CHANGED') {
			Utils.clearCache(this, 'cases-' + msg.campaign_id);

			if (msg.campaign_id == current_campaign_id) {
				this.applyParams(new URLSearchParams(location.search));
			}
		}

		if (msg.type == 'CALL_ENDED') {
			this.applyParams(new URLSearchParams(location.search));
		}
	},
});

// }}}

// Phone number history:

// {{{ Office.PhoneNumberHistoryPanel

GW.define('Office.PhoneNumberHistoryPanel', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'column-panel',
			children: [{
				className: 'toolbar',
				children: [{
					ref: 'search',
					xtype: 'TextField',
					type: 'search',
					extraClass: 'small',
					placeholder: _('Vyhledejte telefonní číslo...'),

					/*
					 * Suggest last called numbers.
					 */
					enableSuggestions: true,
					createSuggestionPopup() {
						return new Office.LastContactSuggestionsPopup();
					},
					'on:submit': (c, v) => {
						c.setValue();

						if (v) {
							this.openSearch(v);
						}
					},
					'on:select': (c, v) => {
						c.setValue();

						if (v) {
							this.openSearch(v);
						}
					},
				}],
			}, {
				className: 'tabs',
				children: [{
					ref: 'tabs',
					xtype: 'Widgets.ButtonSwitcher',
					autofocusActive: true,
					cls: "button-switcher separate",
					renderItem: i => ({
						$data: i,
						'attr:data-item-id': i.id,
						nodeName: 'button',
						className: 'item',
						href: i.href || '#',
						children: [{
							nodeName: 'span',
							className: 'title',
							textContent: i.title,
						}, {
							':skip': i.preventClose || !i.onClose,
							nodeName: 'span',
							className: 'icon-wrapper',
							children: [Utils.useIcon('cross')],
							'on:click': ev => {
								ev.preventDefault();
								i.onClose();
							},
						}],
					}),
					'on:beforeselect': (c, i) => {
						this.selectSearch(i.id);
					},
				}],
			}, {
				ref: 'cards',
				xtype: 'Widgets.CardSwitcher',
			}],
		}, this);

		this.searches = this.loadSearches();
	},

	/*
	 * Searches management.
	 */

	selectSearch(s) {
		Application.route({
			paramsFn: params => {
				if (!s) {
					params.delete('number_history');
				} else {
					params.set('number_history', s);
				}

				return params;
			},
		});
	},

	loadSearches() {
		let searches = localStorage.getItem('number-history-searches-' + Application.session.user.id);

		return searches ? JSON.parse(searches) : [];
	},

	saveSearches() {
		localStorage.setItem('number-history-searches-' + Application.session.user.id, JSON.stringify(this.searches));
	},

	addSearch(search) {
		if (this.searches.some(s => search === s)) {
			return;
		}

		this.searches.unshift(search);
		this.saveSearches();
	},

	removeSearch(search) {
		this.searches = this.searches.filter(s => s !== search);
		this.saveSearches();
	},

	openSearch(s) {
		s = get_international_number(s);

		this.addSearch(s);
		this.selectSearch(s);
	},

	refreshTabs() {
		let tabs = [];

		let prev_tab = null;
		for (let s of this.searches) {
			let next_sel = prev_tab;

			tabs.push({
				id: s,
				title: s,
				onClose: () => {
					this.removeSearch(s);
					this.selectSearch(next_sel);
				},
			});

			prev_tab = s;
		}

		let sel = this.tabs.getSelected();
		this.tabs.setItems(tabs);
		this.tabs.setSelected(sel);

		if (!Application.isMobileUI()) {
			this.search.el.focus();
		}
	},

	reload() {
		Utils.clearCache(this);
		this.applyParams(new URLSearchParams(location.search));
	},

	async applyParams(params) {
		let signal = Utils.abortAndRetry(this, 'reload');

		let search = params.get('number_history');
		if (search) {
			this.addSearch(get_international_number(search));
		}

		this.refreshTabs();
		this.tabs.setSelected(search);
		this.tabs.el.gwHide(this.searches.length == 0);

		if (this.searches.length == 0) {
			this.cards.show({
				id: 'no-number',
				initComponent() {
					this.el = document.gwCreateElement({
						className: 'empty-image-placeholder',
						children: [{
							nodeName: 'img',
							src: APP_BASE + 'img/empty-boxes.svg',
							width: "234",
							height: "190",
						}, {
							className: 'title',
							textContent: _('Vyhledejte telefonní číslo, které vás zajímá'),
						}],
					});
				},
			});
		} else {
			if (!search) {
				search = this.searches[0];
			}
			
			const phone = search.trim().replace(/\s\+/g, ''); 

			await this.cards.show({
				id: 'search_' + phone,
				xtype: 'Office.CallPanel.PhoneNumberHistory',
				phone,
				limit: 1000,
			});
		}
	},
});

// }}}

// {{{ Office.Wallboard

GW.define('Office.Wallboard', 'GW.Component', {
	expandedRows: [],

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			socketSubscriptions: ['call_updates', 'client_connections', 'user_changes', 'queues'],
			children: [{
				ref: 'dataEl',
			}],
		}, this);

		this.reload();

		Utils.interval(this, 'timers-update', 1000, () => this.updateTimers());

		this.resizeObserver = new ResizeObserver(() => this.updateWidths());
		this.resizeObserver.observe(this.dataEl);
	},

	'before:releaseComponent'() {
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
			this.resizeObserver = null;
		}
	},
	
	async reload() {
		let signal = Utils.abortAndRetry(this, 'reload');
		let group_options = Application.getActiveUserGroup().options;

		function countAsFree(user) {
			if (user.followme) {
				// skip any further checks
				return group_options.free_agent_include_followme;
			}

			if (!user.devices || !user.devices.some(d => d.reachable)) {
				return false;
			}

			if (group_options.free_agent_only_agent_app && !user.session_exists) {
				return false;
			}

			return true;
		}

		this.agents = await REST.GET('agents', null, {signal});

		for (let a of this.agents) {
			a.subscribed_queues = a.queues.filter(q => q.state === 'subscribed' || q.state === 'paused').length;
			a.webrtc_reachable = a.devices && a.devices.some(d => d.kind === 'webrtc' && d.reachable);
			a.phone_reachable  = a.devices && a.devices.some(d => d.kind !== 'webrtc' && d.reachable);
			a.is_free = countAsFree(a);

			let is_subscribed = a.subscribed_queues > 0;
			let is_reachable_internally = a.phone_reachable || a.webrtc_reachable;
			let is_reachable = is_reachable_internally || a.followme;

			a.state = {
				subscribed_not_reachable: is_subscribed && !is_reachable,
				available: is_subscribed && is_reachable && !a.in_call && !a.pause && a.is_free,
				in_call: is_subscribed && a.in_call,
				in_pause: is_subscribed && a.pause,

				not_subscribed_not_reachable: !is_subscribed && !is_reachable,
				not_subscribed_reachable: !is_subscribed && is_reachable,

				external_line: !a.in_call && !a.pause && a.followme,
			};

			if (a.state.available || a.state.in_call || a.state.in_pause) {
				a.sort_group = 0;
			} else if (a.state.not_subscribed_reachable) {
				a.sort_group = 1;
			} else if (a.state.subscribed_not_reachable) {
				a.sort_group = 2;
			} else {
				a.sort_group = 3;
			}
		}

		this.agents.sort((a, b) => {
			if (a.sort_group != b.sort_group) {
				return a.sort_group - b.sort_group;
			}

			return a.name.localeCompare(b.name);
		});

		this.dataEl.gwReplaceChildren(this.agents.map(a => this.renderAgent(a)));
		this.updateTimers();
		this.updateWidths();
	},

	updateWidths() {
		if (!this.el) {
			return;
		}
		const agentsElements = this.el.querySelectorAll('.agent-status');
		if (agentsElements.length) {
			let titleMaxWidth = 0;
			let statusMaxWidth = 0;

			// Get width of widest name column
			agentsElements.forEach(el => {
				el.firstElementChild.style.minWidth = null;
				const cw = el.firstElementChild.clientWidth
				titleMaxWidth = cw > titleMaxWidth ? cw : titleMaxWidth;
			});
			
			// Get width of widest status column (including max. title width)
			agentsElements.forEach(el => {
				const tw = titleMaxWidth - el.firstElementChild.clientWidth
				statusMaxWidth = (tw + el.clientWidth) > statusMaxWidth ? (tw + el.clientWidth) : statusMaxWidth;
			});

			agentsElements.forEach(el => {
				// Set same title max width to all title columns
				el.firstElementChild.style.minWidth = (titleMaxWidth) + 'px';

				// Set same status max width to all status columns
				const p = el.parentElement;
				p.style.minWidth = (statusMaxWidth + 12 + 1) + 'px'; // 12 padding 1 border

				// Do we need to show expander button?
				const showExpander = window.innerWidth < 768 || p.parentElement.scrollHeight > p.parentElement.clientHeight || p.parentElement.clientHeight > 51;
				p.parentElement.firstElementChild.classList.toggle('hidden', !showExpander);
			});
		}
	},

	updateTimers() {
		if (!this.el) {
			return;
		}

		const pause_time = (pause) => {
			if (!pause || !pause.start_ts) {
				return '';
			}
			const duration = pause.end_ts ? (pause.end_ts - Date.now()) : (Date.now() - pause.start_ts);
			return Formats.duration_unpadded(Math.max(0, duration));
		};
		this.el.querySelectorAll('.pause-timer').forEach(el => {
			el.textContent = ' ' + pause_time(el.$pause);
		});

		this.el.querySelectorAll('.active-call-dial-ts-timer').forEach(el => {
			el.textContent = ' ' + Formats.duration(Date.now() - el.$dialTs);
		});
	},

	renderAgent(user) {
		const expanded = this.expandedRows.find(e => e === user.user_id);
		return {
			className: 'agent-container ' + ( expanded ? 'expanded' : '' ),
			'attr:data-id': user.user_id,
			children: [{
				nodeName: 'button',
				type: 'button',
				children: [ ( expanded ? Utils.useIcon('arrow-simple-up') : Utils.useIcon('arrow-simple-down'))],
				className: 'expander hidden',
				'on:click': (e) => {
					const expandedIndex = this.expandedRows.indexOf(user.user_id);
					const expanded = expandedIndex === -1;
					
					if (expanded) {
						this.expandedRows.push(user.user_id);
					} else {
						this.expandedRows.splice(expandedIndex, 1);
					}

					e.currentTarget.parentElement.classList.toggle('expanded', expanded);
					e.currentTarget.gwReplaceChildren([Utils.useIcon( expanded ? 'arrow-simple-up' : 'arrow-simple-down')]);
				}
			},{
				className: 'agent-info',
				children: [
					this.renderAgentStatus(user)
				],
			},{
				className: 'agent-queues',
				children: user.queues.map(queue => this.renderQueue(user, queue))
			}
		],
		};
	},

	renderAgentStatus(user) {
		let state = user.state;

		return {
			className: 'agent-status',
			children: [{
				className: 'agent-title',
				children: [{
					className: 'name',
					textContent: user.name,
				}, {
					className: 'extension',
					textContent: user.extension,
					':skip': !user.extension,
				}],
				title: `${user.name + (user.extension ? (' - ' + user.extension) : '')}\n${user.webrtc_reachable ? _('Online') : _('Offline')} - ${user.phone_reachable ? _('Dostupný') : _('Nedostupný')} [${user.subscribed_queues + '/' + user.queues.length}]\n${user.subscribed_queues > 0 ?
						(user.subscribed_queues > 1 ?
							_n(user.subscribed_queues, 'Agent je přihlášen ve {n} frontách') :
							_('Agent je přihlášen v jedné frontě')) :
						_('Agent není přihlášen v žádné frontě')}`,
			}, {
				':skip': !state.subscribed_not_reachable,
				className: 'status-container button xs icon-only static error',
				children: [Utils.useIcon('warningsign')],
				title: _('Agent je přihlášen ve frontách, ale nemá registrované žádné zařízení!'),
			}, {
				':skip': !state.not_subscribed_reachable,
				className: 'status-container button xs icon-only static error-secondary',
				children: [Utils.useIcon('warningsign')],
				title: _('Agent není přihlášen ani v jedné frontě!'),
			}, {
				':skip': !state.not_subscribed_not_reachable,
				className: 'status-container button xs icon-left static grey',
				children: [ Utils.useIcon('error'), {textContent: _('Nedostupný')} ],
			}, {
				':skip': !state.available,
				className: 'status-container button xs icon-left static grey',
				children: [ Utils.useIcon('checkmarkcircle', {cls: 'success'}), {textContent: _('Volný')} ],
				title: _('Aktuálně neprobíhá žádný hovor'),
			}, {
				':skip': !state.external_line,
				className: 'status-container button xs icon-left static grey',
				children: [ Utils.useIcon('checkmarkcircle'), {textContent: _('Externí linka')} ],
				title: _('Agent je přihlášen na externí lince'),
			}, {
				':skip': !state.in_call,
				className: 'status-container button xs icon-left static primary ' + (!user.in_call_connected && 'primary-shadow'),
				children: [Utils.useIcon('phone'), {
					textContent: user.in_call_connected ? _('Hovoří') : _('Vyzvání')
				}, {
					$dialTs: user.active_call_start_ts || user.active_call_ring_ts || user.active_call_dial_ts,
					className: 'active-call-dial-ts-timer',
				}],
			}, {
				':skip': !state.in_pause,
				className: 'status-container button xs icon-left static warning',
				children: [Utils.useIcon( 'play'), {
					title: ((user.pause && user.pause.pause_type) ? user.pause.pause_type.name : ''),
					children: [{
						nodeName: 'span',
						textContent: _('Pauza'),
					}, {
						nodeName: 'span',
						textContent: (user.pause && user.pause.pause_type) ? ' (' + user.pause.pause_type.name + ')' : '',
						className: 'pause-name',
					}, {
						nodeName: 'span',
						$pause: user.pause,
						className: 'pause-timer',
					}]
				}],
			}],
		};
	},

	renderQueue(user, queue) {
		const manageable = !queue.static_membership && Application.getActiveUserGroup().options.agent_can_manage_others_queues;
		return {
			className: 'queue' + (manageable ? ' manageable' : ''),
			'attr:data-status': (user && user.active_calls_queues && user.active_calls_queues.includes(queue.queue)) ? 'in-queue-call' : queue.state, // unsubscribed subscribed paused
			'attr:data-static': queue.static_membership ? '1' : '0',
			title: queue.static_membership ? _c('Přihlášen trvale', 'queue') : undefined,
			'on:click': () => {
				if (manageable) {
					if (queue.state == 'unsubscribed') {
						Office.QueueManager.joinQueue(queue.queue, user.extension);
					} else {
						Office.QueueManager.leaveQueue(queue.queue, user.extension);
					}
				}
			},
			children: [{
				className: 'status',
			}, {
				className: 'info' + (!queue.name ? ' no-name' : ''),
				children: [{
					'skip:': !queue.name,
					className: 'name',
					textContent: queue.name,
					title: queue.name,
				}, {
					className: 'number',
					textContent: queue.queue,
				}],
			}],
		};
	},

	onBusMessage(msg) {
		let monitored_msgs = [
			'CALL_CHANGED',
			'CLIENT_CONNECTED',
			'CLIENT_DISCONNECTED',
			'USERS_CHANGED',
			'QUEUES_CHANGED',
		];

		if (monitored_msgs.includes(msg.type)) {
			Utils.dedupeCalls(this, 'reload', 500, () => this.reload());
		}
	},
	
	applyParams() {
		Application.refreshSubscriptionsFromDOM();
	},
});

// }}}

// Statistics:

// {{{ Office.Statistics

GW.define('Office.Statistics', 'GW.Component', {
	queuesTableOpen: false,
	callbacksTableOpen: false,
	data: {},

	initComponent() {
		this.el = document.gwCreateElement({
			children: [{
				className: 'top-bar',
				children: [{
					nodeName: "h3",
					className: "title",
					textContent: _("Osobní statistiky"),
				}, {
					nodeName: 'button',
					type: 'button',
					className: 'button secondary small icon-left',
					children: [Utils.useIcon('reset'), {textContent: _('Obnovit')}],
					'on:click': () => this.reload(),
				}],
			}, {
				className: "charts",
				ref: "charts",
			}, {
				className: "table",
				children: [{
					className: "panel-header",
					children: [{
						nodeName: "h5",
						className: 'title',
						textContent: _("Příchozí frontové hovory"),
					}, {
						nodeName: "button",
						type: "button",
						ref: "queuesExpander",
						className: 'transparent small icon-only expander',
						children: [ this.queuesTableOpen ? Utils.useIcon('arrow-simple-up') : Utils.useIcon('arrow-simple-down') ],
						"on:click": () => {
							this.queuesTableOpen = !this.queuesTableOpen;
							this.renderQueuesTable(this.queuesTableOpen);
						},
					}]
				}, {
					xtype: "SmartTable",
					extraClass: 'table-alternative',
					ref: "queuesTable",
					getColumns() {
						return [{
							id: "queue",
							name: _("Fronta"),
						}, {
							id: "count",
							name: _("Celkem příchozích"),
						}, {
							id: "count_connected",
							name: _("Dovolané"),
						}, {
							id: "count_not_connected",
							name: _("Nedovolané"),
						}, {
							id: "avg_ring_duration",
							name: _("Průměrná délka vyzvánění"),
							format: "duration",
						}, {
							id: "avg_duration",
							name: _("Průměrná délka hovoru"),
							format: "duration",
						}, {
							id: "sum_duration",
							name: _("Celková délka hovorů"),
							format: "duration",
						}];
					}
				}]
			}, {
				className: "table",
				children: [{
					className: "panel-header",
					children: [{
						nodeName: "h5",
						className: 'title',
						textContent: _("Callback"),
					}, {
						nodeName: "button",
						type: "button",
						ref: "callbacksExpander",
						className: 'transparent small icon-only expander',
						children: [ this.callbacksTableOpen ? Utils.useIcon('arrow-simple-up') : Utils.useIcon('arrow-simple-down') ],
						"on:click": () => {
							this.callbacksTableOpen = !this.callbacksTableOpen;
							this.renderCallbacksTable(this.callbacksTableOpen);
						},
					}]
				}, {
					xtype: "SmartTable",
					extraClass: 'table-alternative',
					ref: "callbacksTable",
					getColumns() {
						return [{
							id: "queue",
							name: _("Fronta"),
						}, {
							id: "callback_count",
							name: _("Celkem callbacků"),
						}, {
							id: "call_count",
							name: _("Zavolání"),
						}, {
							id: "success_count",
							name: _("Pozitivní zakončení"),
						}, {
							id: "fail_count",
							name: _("Negativní zakončení"),
						}, {
							id: "first_reaction_duration_avg",
							name: _("Průměrná doba první reakce"),
							format: "duration",
						}, {
							id: "close_duration_avg",
							name: _("Průměrná doba uzavření"),
							format: "duration",
						}];
					}
				}]
			}],
		}, this);
	},

	renderCharts(data) {
		this.charts.gwReplaceChildren([{
			className: "chart-attendance",
			xtype: "Office.Statistics.BigChart",
			title: _("Docházka"),
			data: data.attendance,
		}, {
			className: "chart-pauses",
			xtype: "Office.Statistics.BigChart",
			title: _("Pauzy"),
			data: data.pauses,
		}, {
			className: "additional-charts",
			children: [{
				nodeName: "h5",
				className: 'title',
				textContent: _("Příchozí hovory - Úroveň služby"),
			}, this.makePercentageChart(data.service_ratio), {
				nodeName: "h5",
				className: 'title',
				textContent: _("Callback - Graf uzavření případů"),
			}, this.makePercentageChart(data.callback_success_rate)],
		}], this);
	},

	renderQueuesTable(expanded) {
		this.queuesExpander.gwReplaceChildren([
			expanded ? Utils.useIcon('arrow-simple-up') : Utils.useIcon('arrow-simple-down'),
		]);

		this.queuesTable.setData(expanded ? this.data.queue_stats : this.data.queue_stats.slice(0, 1));
		this.queuesExpander.disabled = this.data.queue_stats.length < 2;

		if (expanded) {
			setTimeout(this.queuesExpander.parentElement.scrollIntoView({behavior: "smooth", block: "start", inline: "start"}), 150);
		}
	},

	renderCallbacksTable(expanded) {
		this.callbacksExpander.gwReplaceChildren([
			expanded ? Utils.useIcon('arrow-simple-up') : Utils.useIcon('arrow-simple-down'),
		])

		this.callbacksTable.setData(expanded ? this.data.callback_stats : this.data.callback_stats.slice(0, 1));
		this.callbacksExpander.disabled = this.data.callback_stats.length < 2;

		if (expanded) {
			setTimeout(this.callbacksExpander.parentElement.scrollIntoView({behavior: "smooth", block: "start", inline: "start"}), 150);
		}
	},

	makePercentageChart(value) {
		const chartEl = document.gwCreateElement({
			className: "chart",
		});

		Charts.makeDoughnut(chartEl, [{
			value: value,
			color: Utils.getStyleRootProperty("--graph-success-color"),
		}, {
			value: 1-value,
			color: Utils.getStyleRootProperty("--graph-error-color"),
		}]);

		return document.gwCreateElement({
			className: "percentage-chart",
			children: [chartEl, {
				className: "percentage",
				textContent: Formats.percent(value),
			}],
		});
	},

	async reload() {
		let signal = Utils.abortAndRetry(this, 'load-state');

		let data = await REST.GET("/api/personal-statistics", null, {signal});

		if (data.presence.call + data.presence.pause + data.presence.free + data.presence.login === 0) {
			data.presence.login = 1; // add one second to login so we have something to show in the chart
		}

		function chartLabel(label, color_index, color_prefix, value) {
			return {
				label,
				value,
				color: Utils.getStyleRootProperty(`--${color_prefix}-color-${color_index}`) || `hsl(${((color_index + 1) * 50) % 360}, 100%, 40%)`,
			}
		}

		const attendanceData = [
			chartLabel(_("V pauze"), 0, 'attendance', data.presence.pause / 1000),
			chartLabel(_("V hovoru"), 1, 'attendance', data.presence.call / 1000),
			chartLabel(_("Volný"), 2, 'attendance', data.presence.free / 1000),
			chartLabel(_("Přihlášen"), 3, 'attendance', data.presence.login / 1000),
		];

		this.renderCharts({
			attendance: attendanceData,
			pauses: data.pauses.map((pause, i) => chartLabel(pause.name || _('Autopauza'), i, 'pause' , pause.duration / 1000)),
			service_ratio: data.queue_stats[0].count > 0 ? data.queue_stats[0].count_connected / data.queue_stats[0].count : 0,
			callback_success_rate: data.callback_stats[0].callback_count > 0 ? data.callback_stats[0].success_count / data.callback_stats[0].callback_count : 0,
		});

		this.data = data;
		this.data.queue_stats[0].queue = _("Všechny fronty");
		this.data.callback_stats[0].queue = _("Všechny fronty");
		this.renderQueuesTable(this.queuesTableOpen);
		this.renderCallbacksTable(this.callbacksTableOpen);
	},

	async applyParams() {
		await this.reload();
	},
});

// }}}

// {{{ Office.Statistics.BigChart

GW.define("Office.Statistics.BigChart", "GW.Component", {
	title: '',
	data: [],

	initComponent() {
		let noData = false;
		if (this.data.length === 0) {
			noData = true;
			this.data = [{label: null, value: 1, color: Utils.getStyleRootProperty("--input-placeholder")}];
		}

		const total = this.data.map(i => i.value).reduce((a, b) => a + b);

		const doughnut = document.gwCreateElement({className: "chart"});
		Charts.makeDoughnut(
			doughnut,
			this.data.map(i => {
				return {...i, value: i.value/total};
			}),
			null,
			{}, {
				responsive: true,
				aspectRatio: 1.222,
				maintainAspectRatio: true,
				animation: true,
				cutout: '50%',
				events: [],
				borderWidth: 2,
				borderColor: Utils.getStyleRootProperty('--panel-bg'),
				layout: {
					autoPadding: false,
					top: 0,
					bottom: 0,
					left: 20,
					right: 20,
				}
			}
		);

		this.el = document.gwCreateElement({
			className: `big-doughnut`,
			children: [doughnut, {
				className: "legend",
				children: [{
					nodeName: "h5",
					className: 'title',
					textContent: this.title
				}, {
					className: 'detail',
					textContent: _("Celkem {time}").replace("{time}", Utils.secondsToHoursMinutes(noData ? 0 : total))
				}, {
					":skip": noData,
					className: "data",
					children: this.data.map(i => {
						return {
							className: "item",
							children: [{
								className: "dot",
								style: {backgroundColor: i.color}
							}, {
								className: "label",
								textContent: `${Formats.percent(i.value/total)} - ${i.label} (${Utils.secondsToHoursMinutes(i.value)})`
							}]
						}
					})
				}]
			}]
		});
	}
});

// }}}

// {{{ Office.CallRatings

GW.define('Office.CallRatings', 'GW.Component', {

	renderCallParty: Office.CallsListMixin.renderCallParty,
	
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus column-panel',
			socketSubscriptions: ['call_ratings'],
			children: [{
				className: 'toolbar',
				children: [{
					className: "toolbar-top",
					children: this.renderFilter(),
				}],
			}, {
				ref: 'table',
				xtype: 'SmartTable',
				monitorOverflow: true,
				getColumns: () => this.getColumns(),
			}],
		}, this);
	},

	renderFilter() {
		return [{
			ref: 'filterConfirmed',
			xtype: 'Widgets.ButtonSwitcher',
			cls: 'button-switcher small',
			items: [{
				id: 'all',
				value: 'all',
				title: _('Vše'),
			}, {
				id: 'no',
				value: 'no',
				title: _('Nepřečtené'),
			}, {
				id: 'yes',
				value: 'yes',
				title: _('Přečtené'),
			}],
			'on:beforeselect': (c, i) => {
				Application.route({
					paramsFn: params => {
						this.filterConfirmed.setSelected(i.value)
						params.set('rating_confirmed', i.value);
						return params;
					},
				});
			},
		}];
	},

	renderPhoneNumber(ct, number) {
		ct.textContent = number || '';
	},
	
	getColumns() {
		const me = this;
		return [{
			id: 'direction',
			name: '',
			formatCell(td, v, row) {
				td.gwCreateChild(Office.renderDirectionIcon(row));
			},
		}, {
			id: 'caller',
			name: _('Volající'),
			formatCell(td, v, row) {
				td.gwReplaceChildren(me.renderCallParty(v));
			},
		}, {
			id: 'queue',
			name: _('Vstupní fronta'),
			formatCell(td, v, row) {
				td.gwReplaceChildren([{
					':skip': !row.queue_name,
					textContent: row.queue_name,
					className: 'text-nowrap',
				}, {
					textContent: row.queue,
					className: row.queue_name ? 'text-sm' : '',
				}]);
			},
		}, {
			id: 'start',
			format: 'datetime',
			name: _('Datum'),
		}, {
			id: 'rating',
			name: _('Hodnocení'),
			formatCell(td, v, row) {
				td.classList.add('call-rating-td');
				td.classList.add('flex');
				td.classList.add('align-center');
				td.classList.add('gap-1');
				td.gwReplaceChildren([
					Formats.call_rating_icon(row.rating),
					{
						className: !!row.confirmed_ts ? 'cursor-help' : undefined,
						children: [Utils.useIcon('check', {cls: !!row.confirmed_ts ? 'text-muted' : 'vhidden'})],
						title: !!row.confirmed_ts ? _('Přečteno') : undefined,
					}, {
						nodeName: 'button',
						className: 'small secondary icon-only',
						children: [Utils.useIcon('award')],
						title: _('Hodnocení hovoru'),
						'on:click': e => {
							new Main.Dialog({
								title: _('Hodnocení hovoru'),
								'after:initComponent'() {
									this.bodyEl.gwReplaceChildren([{
										ref: 'rating',
										xtype: 'CDR.CallRating',
										call_id: row.call_id,
										ref_user_id: row.ref_user_id,
									}], this);
								},
							});
						},
					}
				]);
			}
		}, {
			hidden: !Application.getActiveUserGroups().some(g => !['regular', 'agent'].includes(g.member_role) || g.options.show_recordings),
			id: 'ctl',
			name: _('Akce'),
			formatCell(td, v, row) {
				td.gwCreateChild({
					nodeName: 'button',
					className: 'small secondary icon-only',
					children: [Utils.useIcon('dialing')],
					title: row.recordings_readable ? _('Zobrazit nahrávky') : _('K nahrávkám nemáte přístup'),
					disabled: !row.recordings_readable,
					'on:click': ev => me.showRecordings(row.call_id),
				});
			}
		}].filter(c => !c.hidden);
	},

	async showRecordings(call_id) {
		let recordings = await REST.GET('calls/' + encodeURIComponent(call_id) + '/recordings');

		let dlg = new CDR.CallRecordingsDialog({
			call_id,
			recordingsBaseUrl: API_BASE + 'calls/' + encodeURIComponent(call_id) + '/recordings/',
			showCallRatings: false, // this is already shown from the call rating table, no need to show them again
		});

		dlg.setRecordings(recordings);
	},
	
	getQueryParams(params) {
		const confirmed = params.get('rating_confirmed') || 'no';
		this.filterConfirmed.setSelected(confirmed);
		return {confirmed, ref_user_id: Application.session.user.id};
	},

	async applyParams(params) {
		let signal = Utils.abortAndRetry(this, 'reload');

		const query = this.getQueryParams(params);

		let call_ratings = await REST.GET('call-ratings', query, {signal});

		this.table.setData(call_ratings);
	},

	onBusMessage(msg) {
		if (msg.type == 'CALL_RATINGS_CHANGE') {
			this.applyParams(new URLSearchParams(location.search));
		}
	},
});

// }}}

// Callback:

// {{{ Office.AgentCallbackPanel

GW.define('Office.AgentCallbackPanel', 'GW.Component', {
	buttonSwitcherExtraClass: '',
	
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus column-panel',
			children: [{
				className: 'toolbar',
				children: [{
					className: "toolbar-top",
					children: [{
						ref: 'tabs',
						xtype: 'Widgets.ButtonSwitcher',
						autofocusActive: true,
						cls: "button-switcher small campaign-switcher " + this.buttonSwitcherExtraClass,
						'on:beforeselect': (c, i) => {
							Application.route({
								paramsFn: params => {
									params.set('callback_queue', i.id);
									return params;
								},
							});
						},
					}, {
						ref: 'filter',
						xtype: 'SelectField',
						cls: 'small',
						popupAutoWidth: false,
						options: this.getFilterOptions(),
						'on:change': c => {
							Application.route({
								paramsFn: params => {
									params.set('callback_filter', c.getValue());
									return params;
								},
							});
						},
					}],
				}],
			}, {
				ref: 'cards',
				xtype: 'Widgets.CardSwitcher',
			}],
		}, this);
		
		// reload queues only if queue manager is not active. The queues may be not loaded or outdated in this cases.
		if (!Office.QueueManager.active) {
			Office.QueueManager.loadQueues(false);
		}
	},

	getFilterOptions() {
		return [{
			id: 'all',
			value: 'all',
			text: _('Všechny případy'),
			query: {},
		}, {
			id: 'open',
			value: 'open',
			text: _('Všechny otevřené'),
			query: {
				status: 'not-closed',
			},
		}, {
			id: 'mine',
			value: 'mine',
			text: _('Moje otevřené'),
			query: {
				mine: true,
				status: 'not-closed',
			},
		}, {
			id: 'all-closed',
			value: 'all-closed',
			text: _('Všechny uzavřené'),
			query: {
				status: 'closed',
			},
		}, {
			id: 'mine-closed',
			value: 'mine-closed',
			text: _('Moje uzavřené'),
			query: {
				mine: true,
				status: 'closed',
			},
		}, {
			id: 'new',
			value: 'new',
			text: _('Nezahájené'),
			query: {
				status: 'new',
			},
		}];
	},

	renderPhoneNumber(ct, number) {
		ct.textContent = number || '';
	},

	getListComponentConfig() {
		let me = this;

		return {
			xtype: 'SmartTable',
			monitorOverflow: true,
			extraClass: 'outbound-cases-smart-table js-msgbus',
			getColumns() {
				return [{
					id: 'contact_phone',
					name: _('Telefon'),
					formatCell(td, v, row) {
						me.renderPhoneNumber(td, v);
						td.prepend(
							td.gwCreateChild({
								nodeName: 'span',
								className: 'icon-wrapper',
								title: row.requested_by_caller ? _('Vyžádaný callback') : _('Zmeškaný hovor'),
								children: [
									row.requested_by_caller ? 
										Utils.useIcon('notificationsfilled', {cls: 'warning'})
									:
										Utils.useIcon('phone-missed', {cls: 'muted'})
								],
							})
						);
					},
				}, {
					id: 'contact_name',
					name: _('Jméno'),
				}, {
					id: 'contact_company',
					name: _('Firma'),
				}, {
					id: 'queue',
					name: _('Fronta'),
					formatCell(td, v, row) {
						td.gwReplaceChildren([{
							':skip': !row.queue_name,
							textContent: row.queue_name,
							className: 'text-nowrap',
						}, {
							textContent: row.queue,
							className: row.queue_name ? 'text-sm' : '',
						}])
					},
				}, {
					id: 'first_agent_exten',
					name: _('Linka'),
					formatCell: (td, v, row) => {
						if (row.first_agent_more) {
							td.gwReplaceChildren([{
								nodeName: 'em',
								textContent: _('Více agentů'),
							}])
						} else {
							me.renderPhoneNumber(td, v, row);
						}
					},
				}, {
					id: 'first_agent_name',
					name: _('Agent'),
				}, {
					id: 'last_missed',
					name: _('Čas zmeškaného hovoru'),
					format: 'datetime',
				}, {
					id: 'contact_incomming_misses',
					name: _('Počet zmeškání'),
				}, {
					id: 'agent_outgoing_attempts',
					name: _('Počet pokusů'),
				}, {
					id: 'last_contact',
					name: _('Čas posledního pokusu'),
					format: 'datetime',
				}, {
					id: 'last_did',
					name: _('Poslední DID'),
				}, {
					id: 'last_agent_name',
					name: _('Vyřizuje'),
				}, {
					id: 'last_agent_exten',
					name: _('Linka'),
					formatCell: me.renderPhoneNumber,
				}, {
					id: 'closing_agent_name',
					name: _('Uzavřel'),
					width: 25,
				}, {
					id: 'closed',
					name: _('Čas uzavření'),
					format: 'datetime',
					width: 20,
				}, {
					id: 'ctl',
					name: _('Akce'),
					formatCell: (...args) => me.renderCaseControls(...args),
				}];
			},

			renderRow(tr, row) {
				tr.dataset.status = row.status || '';
				tr.dataset.mine = row.last_agent_user_id == Application.session.user.id ? '1' : '0';
			},

			refreshControls() {
				for (let btn of this.el.querySelectorAll('button[data-action]')) {
					let action = btn.dataset.action;
					switch (action) {
					case 'outbound-case-notes':
					case 'callback-case-show-voicemails':
						btn.disabled = false;
						break;
					case 'outbound-case-close':
					case 'outbound-case-close-fail':
						btn.disabled = false; //XXX: disable when other agent is working on this case
						break;
					default:
						btn.disabled = !Office.CallManager.canDo(action);
						break;
					}
				}
			},

			onBusMessage(msg) {
				if (msg.type == 'CALL_MANAGER_CHANGE') {
					this.refreshControls();
				}
			},

			'after:setData'() {
				this.refreshControls();
			},
		};
	},

	renderCaseControls(td, v, row) {
		if (this.showDialButton()) {
			td.gwCreateChild({
				nodeName: 'button',
				className: 'success icon-only small',
				'attr:data-action': 'dial',
				title: _('Vytočit'),
				'on:click': ev => {
					this.onDial(row);
				},
			});
		}

		td.gwCreateChild({
			nodeName: 'button',
			className: 'secondary icon-only small' + (row.has_notes ? ' filled' : ''),
			'attr:data-action': 'outbound-case-notes',
			title: _('Poznámky'),
			'on:click': ev => {
				ev.preventDefault();
				this.showNotesDialog(row);
			},
		});

		if (row.status === 'closed') {
			if (row.close_result) {
				td.gwCreateChild({
					nodeName: 'span',
					className: 'status icon ' + (row.close_result === 'success' ? 'success' : 'error'),
					children: [Utils.useIcon(row.close_result === "success" ? 'check' : 'cross'), {
						textContent: (row.close_result === "success" ? _('Úspěšné') : _('Neúspěšné'))
					}]
				});
			}
		} else {
			td.gwCreateChild({
				nodeName: 'button',
				className: 'icon-only small ' + (row.close_result == 'success' ? 'primary selected' : 'secondary'),
				'attr:data-action': 'outbound-case-close',
				title: _('Uzavřít - úspěšné'),
				'on:click': ev => {
					ev.preventDefault();
					this.closeCase(row, 'success');
				},
			});

			td.gwCreateChild({
				nodeName: 'button',
				className: 'icon-only small ' + (row.close_result == 'fail' ? 'primary error selected' : 'secondary'),
				'attr:data-action': 'outbound-case-close-fail',
				title: _('Uzavřít - neuspěšné'),
				'on:click': ev => {
					ev.preventDefault();
					this.closeCase(row, 'fail');
				},
			});
		}

		if (row.has_voicemails) {
			td.gwCreateChild({
				nodeName: 'button',
				className: 'icon-only small secondary',
				'attr:data-action': 'callback-case-show-voicemails',
				title: _('Zobrazit nahrávky callbacku'),
				'on:click': ev => {
					ev.preventDefault();
					this.showVoicemails(row);
				},
			});
		}
	},

	async closeCase(data, close_result) {
		await REST.POST('callback-cases/' + encodeURIComponent(data.id) + '/close', {close_result});
		this.reload();
	},

	async showVoicemails(callback_case) {
		let voicemails = await REST.GET('voicemails?callback_case_id=' + encodeURIComponent(callback_case.id));

		let dlg = new CDR.CallVoicemailsDialog({
			title: _('Záznamník u callbacku'),
		});

		dlg.setVoicemails(voicemails);

		this.activateCase(callback_case)
	},

	showNotesDialog(data) {
		new Main.NotesDialog({
			onSave(text) {
				return REST.POST('callback-cases/' + encodeURIComponent(data.id) + '/comments', {
					text,
				});
			},

			loadData(signal) {
				return REST.GET('callback-cases/' + encodeURIComponent(data.id) + '/comments', null, {signal});
			},
		});
	},

	async activateCase(callback_case) {
		if (callback_case.status == 'closed') {
			return;
		}
		await REST.POST('callback-cases/' + encodeURIComponent(callback_case.id) + '/activate');
		this.reload();
	},

	async onDial(data) {
		await this.activateCase(data);
		
		let number = await Office.QueueManager.makeQueueAssignmentNumber(data.queue, data.contact_phone);

		Office.CallManager.doAction({action: 'dial', number, send_metadata: {callback_case: data.id}});
	},

	showDialButton() {
		return true;
	},

	reload() {
		Utils.clearCache(this);

		this.applyParams(new URLSearchParams(location.search));
	},

	cachedReload() {
		this.applyParams(new URLSearchParams(location.search));
	},

	async applyParams(params) {
		let signal = Utils.abortAndRetry(this, 'reload');

		/*
		 * Update toplevel tabs (queue list)
		 */
		let tabs = Office.QueueManager.queues.map(c => {
			return {
				id: 'queue-' + c.queue,
				title: c.queue + (c.name ? ` - ${c.name}` : ''),
				queue: c.queue,
			};
		});

		tabs.unshift({
			id: 'any-queue',
			title: _('Všechny'),
			queue: '*',
		});
		if (Application.getActiveUserGroup().options.show_ivr_missed_calls) {
			tabs.push({
				id: 'ivr',
				title: _('Zmeškané v IVR'),
				queue: 'none',
			});
		}

		this.tabs.setItems(tabs);

		/*
		 * Handle the "no queues" case.
		 */
		this.el.classList.toggle('no-queues', tabs.length == 1);

		if (tabs.length == 1) {
			this.description = '';
			this.cards.show({
				id: 'no-queues',
				initComponent() {
					this.el = document.gwCreateElement({
						className: 'empty',
						textContent: _('Žádné fronty nejsou k dispozici'),
					});
				},
			});
			return;
		}

		/*
		 * Handle queue selection.
		 */
		let tabId = params.get('callback_queue');
		let tab = tabs.find(t => t.id == tabId) || tabs[0];
		this.tabs.setSelected(tab.id);

		/*
		 * Handle case filter type selection.
		 */
		let filterId = params.get('callback_filter');
		let filter = this.filter.options.find(i => i.value == filterId) || this.filter.options[1];
		this.filter.setValue(filter.value);

		/*
		 * Render or activate the case list.
		 */
		let c = await this.cards.show({
			id: 'cases',
			...this.getListComponentConfig(),
		});

		/*
		 * If user does not have extension assigned, don't try to load
		 * the cases.
		 */
		let extension = Application.session.user.extension;
		if (extension == null) {
			c.setData([]);
			return;
		}

		/*
		 * Update the case list.
		 */
		let [cases, casesChanged] = await Utils.cache(this, 'cases', 60000,
			REST.GET, 'callback-cases', {...filter.query, queue: tab.queue}, {signal});
		if (casesChanged) {
			c.setData(cases);
		}
	},

	onBusMessage(msg) {
		let tab = this.tabs.getSelectedItemData();

		if (msg.type == 'QUEUE_MANAGER_QUEUES_LIST_CHANGE') {
			this.dedupeCachedReload();
		}

		if (msg.type == 'CALLBACK_CASE_CHANGED') {

			let tab_queue = tab ? tab.queue : null;
			
			if (tab_queue == '*' || msg.queue == tab_queue || (!msg.queue && tab_queue == 'none')) {
				Utils.clearCache(this, 'cases');
				this.dedupeCachedReload();
			}
		}

		if (msg.type == 'CALL_ENDED') {
			this.dedupeCachedReload();
		}
	},
	
	// uses dedupe only for non first events. The first reload request should be processed immediately
	dedupeCachedReload() {
		if (!this.firstLoaded) {
			this.cachedReload();
			this.firstLoaded = true;
		} else {
			Utils.dedupeCalls(this, 'reload', 2000, () => this.cachedReload());
		}
	}
});

// }}}
// {{{ Office.AgentDialer

GW.define('Office.AgentDialer', 'GW.Component', {
	initComponent() {
		const me = this;
		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			children: [{
				ref: 'officeDialer',
				xtype: 'Office.Dialer',
				'after:initComponent'() {
					this.inputOptions.gwReplaceChildren([{
						xtype: 'SelectField',
						cls: 'small project-select',
						ref: 'projectSelect',
						placeholder: _('Bez projektu'),
						'on:change': el => {
							localStorage.setItem('agent-dialer-project', el.getValue());
						}
					}], me);
				},
				async 'wrap:callManagerAction'(origFn, args) {
					if (args.action === 'dial') {
						const selectedProjectQueue = me.projectSelect.getValue();
						if (selectedProjectQueue) {
							args.number = await Office.QueueManager.makeQueueAssignmentNumber(selectedProjectQueue, args.number, true);
						}
					}
					origFn(args);
				}
			}, {
				className: 'office-waiting-queues panel-container js-msgbus',
				children: [{
					nodeName: 'h4',
					textContent: _('Frontové požadavky'),
				}, {
					className: 'call-list',
					ref: 'queueCallsList',
				}],
			}],
		}, this);

		Utils.interval(this, 'timer-update', 1000, () => this.updateTimers());

		this.renderQueueCallsList(Office.QueueManager.queued_calls);
	},

	updateProjectSelect() {
		let select = this.projectSelect;

		let queues = Office.QueueManager.queues
			.filter(q => q.supports_out_prefix)
			.filter(q => (
				(Application.getActiveUserGroup().options.projects_show_queues && q.type == 'agent') ||
				(Application.getActiveUserGroup().options.projects_show_personal_queues && q.type == 'personal')
			))
			.sort((q1, q2) => ((q2.type == 'personal') - (q1.type == 'personal'))); // sort personal first

		if (queues.length <= 0) {
			select.el.gwHide(true);
			return;
		}
		select.el.gwHide(false);

		const separator = {
			render: {
				className: 'option separator',
			},
		}

		select.setOptions([
			{
				text: _('Bez projektu'),
				value: null,
			},
			separator,
			...queues.flatMap((q, i, arr) => [
				...(i > 0 && arr[i].type != arr[i-1].type ? [separator] : []),
				{
					text: (q.name ? (q.name + ' - ') : '') + q.queue,
					value: q.queue
				}
			]),
		]);
		
		select.setValue(localStorage.getItem('agent-dialer-project'));
	},

	renderQueueCallsList({calls, details}) {
		if (!calls || calls.length <= 0) {
			this.queueCallsList.gwReplaceChildren([{
				textContent: _('Žádné frontové požadavky'),
			}]);
			this.queueCallsList.parentNode.classList.add('queue-empty')
			return;
		} else {
			this.queueCallsList.parentNode.classList.remove('queue-empty')
		}

		this.queueCallsList.gwReplaceChildren(calls.map(call => {
			const contact = details && details.contacts.find(c => c.phone == call.caller);
			const queue = details && details.queues.find(q => q.queue == call.queue);
			const callee = call?.callee?.number ? {
				number: call.callee.number,
				...(details && details.contacts.find(c => c.phone == call.callee.number) || {})
			} : {};

			return {
				className: 'call-container',
				children:[ {
					className: 'call-type-container',
					children: [{
						className: 'call-type-icon',
						children: [Utils.useIcon('phone')],
					}]}, {
					className: 'call',
					children: [{
						className: 'number',
						textContent: call.caller,
					}, {
						className: 'contact',
						textContent: contact ? [contact.name, contact.company].filter(v => v).join(', ') : '',
					}, {
						className: 'queue',
						textContent: _('Fronta') + ' ' + call.queue + ((queue && queue.name) ? ` - ${queue.name}` : ''),
					}, {
						':skip': !(call.queue_welcome_ts && !call.queue_join_ts),
						className: 'queue-welcome',
						textContent: _('Přehrává úvodní hlášku'),
					}, {
						className: 'queue-timer ' + ((call.queue_welcome_ts && !call.queue_join_ts) ? 'queue-timer-welcome' : ''),
						$queue_ts: call.queue_join_ts || call.queue_welcome_ts,
					}, {
						':skip': !callee.number,
						className: 'callee',
						textContent: callee.number + (() => {
							const info = [callee.name, callee.company].filter(v => v).join(', ');
							return info ? ( ' - ' + info) : '';
						})(),
					}],
				}]
			};
		}));

		this.updateTimers();
	},

	updateTimers() {
		for (let el of this.queueCallsList.querySelectorAll('.queue-timer')) {
			el.textContent = el.$queue_ts ? Utils.getElapsedTime(el.$queue_ts) : '';
		}
	},

	async showCallEndedDialog(call_id, queue) {
		let selectCategory = Application.getActiveUserGroup().options.force_select_category;
		let addNote = Application.getActiveUserGroup().options.force_add_note;
		let categoryIsSet = false;

		let hierarchy;
		if (selectCategory) {
			hierarchy = await Office.QueueManager.getCategoryHierarchy(queue);
			if (!hierarchy) {
				// do not show category selection if no hierarchy set for given queue
				selectCategory = false;
			} else {
				const call_info = await REST.GET('call-info/' + encodeURIComponent(call_id));
				categoryIsSet = call_info.call_category && call_info.call_category.length > 0;
			}
		}

		if (!selectCategory && !addNote) {
			// dialog will not be shown
			return;
		}
		if (selectCategory && !addNote && categoryIsSet) {
			// only category selection is requested, but category already set, no need to show the dialog
			return;
		}

		/* best effor call info fetch */
		let detail;
		try {
			detail = await REST.GET('calls/' + encodeURIComponent(call_id));
		} catch (ex) { }

		new Main.FormDialog({
			allowCloseButton: false,
			disableSubmitOnInvalidForm: true,

			title: (selectCategory && addNote) ?
				_('Vybrat kategorii a přidat poznámku') : (
				selectCategory ? _('Vybrat kategorii') : _('Přidat poznámku')
			) + (hierarchy ? (' - ' + hierarchy.name) : ''),

			'after:initComponent'() {
				this.el.classList.add('call-ended-dialog');

				if (this.categoriesField) {
					this.categoriesField.setCategoryList(hierarchy.categories);
				}

				this.focus();
			},

			renderFormFields() {
				return [{
					':skip': !detail,
					ref: 'detailEl',
					xtype: 'FormField',
					label: _('Pro hovor z'),
					optional: true,
					renderInput() {
						return {
							ref: 'input',
							textContent: Formats.datetime(detail.begin_ts),
						};
					},
				}, {
					':skip': !detail,
					ref: 'detailEl',
					xtype: 'FormField',
					label: _('Volající a volaný'),
					optional: true,
					renderInput() {
						return {
							ref: 'input',
							children: [
								detail.caller,
								' -> ',
								detail.last_callee,
							],
						};
					},
				}, {
					':skip': !selectCategory,
					ref: 'categoriesField',
					name: 'category',
					xtype: 'Office.CallPanel.CategorySelector',
				}, {
					':skip': !addNote,
					ref: 'noteField',
					name: 'note',
					xtype: 'TextareaField',
					label: _('Přidat poznámku k hovoru'),
				}];
			},

			async onSave(data) {
				// parallel - make it faster and don't let one error fail the other request
				await Promise.all([
					selectCategory && REST.PUT('call-info/' + encodeURIComponent(call_id), {category: data.category}),
					addNote && REST.POST('call-info/' + encodeURIComponent(call_id) + '/notes', {note: data.note}),
				]);
			},
		});
	},

	showCallbackCaseCallEndedDialog(outbound_case_id) {
		new Main.Dialog({
			title: _('Zvolte výsledek hovoru'),
			allowCloseButton: false,
			'after:initComponent'() {
				this.bodyEl.gwCreateChild({
					className: 'form-buttons centered',
					children: [{
						nodeName: 'button',
						type: 'button',
						className: 'success large icon-left',
						children: [ Utils.useIcon('checkmarkcircle'), {textContent: _('Úspěch'),}],
						'on:click': async () => {
							// hide dialog and make request in the background - don't block dialog on error or timeout
							PopupManager.hide(this);
							await REST.POST('callback-cases/' + encodeURIComponent(outbound_case_id) + '/close', {close_result: 'success'});
						},
					}, {
						nodeName: 'button',
						type: 'button',
						className: 'error large icon-left',
						children: [ Utils.useIcon('error'), {textContent: _('Neúspěch'),}],
						'on:click': async () => {
							// hide dialog and make request in the background - don't block dialog on error or timeout
							PopupManager.hide(this);
							await REST.POST('callback-cases/' + encodeURIComponent(outbound_case_id) + '/close', {close_result: 'fail'});
						},
					}],
				});
				this.footerEl.gwCreateChild({nodeName:'br'});
			},
		});
	},

	onBusMessage(msg) {
		const my_exten = Application.session.user.extension

		if (msg.type === 'CALL_ENDED' &&
			(msg.last_callee == my_exten || msg.caller == my_exten) &&
			msg.queue
		) {
			// this is called only for connected calls, not connected queue calls does not have
			// callee (neither last_callee) set
			this.showCallEndedDialog(msg.call_id, msg.queue)
				// don't bother the user with error not related to CALL_ENDED event
				.catch(console.error);
		}
		
		if (msg.type === 'CALL_ENDED' && 
			msg.caller == my_exten &&
			Application.getActiveUserGroup().options.show_window_for_callback_case_close
		) {
			REST.GET('call-info/' + msg.call_id).then(({call_metadata}) => {
				if (call_metadata && call_metadata.callback_case) {
					this.showCallbackCaseCallEndedDialog(call_metadata.callback_case);
				}
			}).catch(console.error);
		}
		
		if (msg.type === 'QUEUE_MANAGER_QUEUES_LIST_CHANGE') {
			this.updateProjectSelect();
		}

		if (msg.type == 'QUEUE_MANAGER_QUEUED_CALLS_CHANGE') {
			this.renderQueueCallsList(Office.QueueManager.queued_calls);
		}
	},
});

// }}}
// {{{ Office.AgentPanel

GW.define('Office.AgentPanel', 'Office.OfficePanel', {
	title: _('Agent panel'),
	titleIcon: 'headphones',

	/*
	 * PLUGIN: extension point
	 */
	extendOfficePanel() {
		this.queueControl = new Office.QueueControlPanel({
			'after:initComponent'() {
				this.el.classList.add('page-centered-container');
			},
		});

		this.bodyEl.before(this.queueControl.el);

		this.reloadAnnouncement();
		Utils.alignedInterval(this, 'midnight', 'day', 5000, () => this.reloadAnnouncement());
	},

	getDialerConfig() {
		return {
			xtype: 'Office.AgentDialer',
		};
	},

	renderPhoneNumber(ct, number) {
		if (number) {
			ct.gwCreateChild({
				nodeName: 'a',
				className: 'phone-number-link',
				textContent: number,
				href: '#',
			});
		}
	},

	/*
	 * PLUGIN: extension point
	 */
	getUnfilteredControlPanelTabs() {
		return  [{
			id: 'call',
			icon: 'document',
			iconActive: 'documentfilled',
			title: _('Karta hovoru'),
			href: '#',
			card: {
				xtype: 'Office.CallPanel',
			},
		}, {
			id: 'speeddial',
			icon: 'dashboard',
			iconActive: 'dashboard-filled',
			title: _('Rychlé volby'),
			href: '#',
			card: {
				xtype: 'Office.Speeddial',
			},
		}, {
			id: 'history',
			icon: 'phone',
			iconActive: 'phone-filled',
			title: _('Historie volání'),
			href: '#',
			card: {
				xtype: 'Office.HistoryPanel',
				renderPhoneNumber: this.renderPhoneNumber,
			},
		}, {
			id: 'queuehistory',
			icon: 'queue',
			iconActive: 'queue-filled',
			title: _('Historie front'),
			href: '#',
			card: {
				xtype: 'Office.AgentHistoryPanel',
				renderPhoneNumber: this.renderPhoneNumber,
			},
		}, {
			id: 'callback',
			icon: 'phone-missed',
			iconActive: 'phone-missed-filled',
			title: _('Callback'),
			href: '#',
			card: {
				xtype: 'Office.AgentCallbackPanel',
				renderPhoneNumber: this.renderPhoneNumber,
			},
		}, {
			id: 'mailbox',
			icon: 'voicemail',
			iconActive: 'voicemail-filled',
			title: _('Záznamník'),
			href: '#',
			card: {
				xtype: 'Office.Mailbox',
			},
		}, {
			id: 'outbound',
			icon: 'phone-outgoing',
			iconActive: 'phone-outgoing-filled',
			title: _('Odchozí kampaně'),
			href: '#',
			card: {
				xtype: 'Office.AgentOutboundPanel',
				renderPhoneNumber: this.renderPhoneNumber,
			},
		}, {
			id: 'numberhistory',
			icon: 'phone',
			iconActive: 'phone-filled',
			title: _('Historie čísel'),
			href: '#',
			card: {
				xtype: 'Office.PhoneNumberHistoryPanel',
			},
		}, {
			id: 'wallboard',
			icon: 'headphones',
			iconActive: 'headphones-filled',
			title: _('Agenti'),
			href: '#',
			card: {
				xtype: 'Office.Wallboard',
			},
		}, {
			id: 'stats',
			icon: 'chart',
			iconActive: 'chart-filled',
			title: _('Statistiky'),
			href: '#',
			card: {
				xtype: 'Office.Statistics',
			},
		}, {
			id: 'ratings',
			icon: 'emoji',
			iconActive: 'emoji-happy',
			title: _('Hodnocení'),
			href: '#',
			card: {
				xtype: 'Office.CallRatings',
				renderPhoneNumber: this.renderPhoneNumber,
			},
		}, {
			id: 'directory',
			icon: 'book',
			iconActive: 'book-filled',
			title: _('Adresář'),
			href: '#',
			card: {
				xtype: 'Office.DirectoryPanel',
				renderPhoneNumber: this.renderPhoneNumber,
			},
		}];
	},

	getControlPanelTabs(hiddenTabs) {
		if (!hiddenTabs) {
			hiddenTabs = Application.getActiveUserGroup().options.hidden_agent_panel_tabs || [];
		}

		return this.getUnfilteredControlPanelTabs().filter(tab => !hiddenTabs.includes(tab.id));
	},

	'wrap:getMovedCards'(fn) {
		let tabs = fn();
		let me = this;

		if (Application.getResponsivityMatch('<md')) {
			return [{
				id: 'queues',
				icon: 'phone-call',
				title: _('Fronty'),
				href: '#',
				card: {
					xtype: 'Office.QueueControlPanel',
					applyParams(params) {
						this.redrawQueues();
					},
				},
			}, ...tabs];
		}

		return tabs;
	},

	'after:layoutAutoHide'() {
		const ltmd = Application.getResponsivityMatch('<md');

		this.queueControl.el.gwHide(ltmd);

		if (!ltmd) {
			this.control.cards.remove('queues');
		}
	},

	'after:initComponent'() {
		this.el.addEventListener('click', ev => {
			if (ev.target.matches('a.phone-number-link')) {
				ev.preventDefault();

				Application.route({
					paramsFn: params => {
						params.set('number_history', ev.target.textContent);
						params.set('tab', 'numberhistory');
						return params;
					},
				});
			}
		}, true);

		Office.QueueManager.start();
	},

	'before:destroy'() {
		Office.QueueManager.end();
	},

	'after:requestReload'() {
		Utils.abortDedupeCalls(this, 'update-callback-stats');
		this.reloadCallbackStats();
	},

	renderCallbackStats() {
		let queues = this.callbackStats || [];
		let total = queues.reduce((tot, q) => tot + q.new_cases, 0);
		this.control.tabs.setNotification('callback', total);
	},

	async reloadCallbackStats() {
		let signal = Utils.abortAndRetry(this, 'reload-callback-stats');

		this.callbackStats = await REST.GET('callback-cases/summary', null, {signal});

		this.renderCallbackStats();
	},

	'after:onBusMessage'(msg) {
		if (msg.type === 'CLIENT_WEBSOCKET_STATUS_CHANGE' && msg.ready) {
			this.requestReload();
		}

		if (msg.type === 'CALLBACK_CASE_CHANGED') {
			Utils.dedupeCalls(this, 'update-callback-stats', 1000, () => this.reloadCallbackStats());
		}
		// for messaging stats, see Office.Messaging.Stats.subscribeUnreadCountChange()

		if (msg.type == 'SWITCH_TO_CALL_PANEL') {
			Application.route({
				paramsFn: params => {
					params.set('tab', 'call');
					return params;
				},
			});
		}

		if (msg.type == 'ANNOUNCEMENT_CHANGED' && msg.group_id == Application.getActiveUserGroup()?.id) {
			this.reloadAnnouncement();
		}
	},

	async reloadAnnouncement() {
		const signal = Utils.abortAndRetry(this, 'reload-announcement');
		const announcement = await REST.GET('announcements/current', null, {signal});

		if (this.shownAnnouncement) {
			this.shownAnnouncement.remove();
			this.shownAnnouncement = null;
		}

		if (announcement) {
			this.shownAnnouncement = document.gwCreateElement({
				className: 'announcement panel-container',
				children: [{
					className: 'icon-wrapper',
					children: [Utils.useIcon('megaphone')]
				}, {
					className: 'title',
					children: [{
						className: 'name',
						textContent: announcement.sender,
					}, {
						className: 'date',
						textContent: Formats.datetime(announcement.created),
					}]
				}, {
					className: 'content',
					textContent: announcement.content,
				}],
			}, this);
			this.control.controlPanel.before(this.shownAnnouncement);
		}
	}
});

// }}}
// {{{ Office.AgentSubscriptionWarningDialog

GW.define('Office.AgentSubscriptionWarningDialog', 'Main.Dialog', {
	title: _('Stále jste přihlášeni ve frontách'),
	queues: [],

	'after:initComponent'() {
		this.promise = Utils.makeCompleter();

		this.bodyEl.gwReplaceChildren([{
			nodeName: 'p',
			children: [_('Jste přihlášeni v těchto forntách') + ': ', {
				nodeName: 'strong',
				textContent: this.queues.join(', '),
			}],
		}, {
			nodeName: 'p',
			children: [
				{ nodeName: 'br' }, 
				_('Chcete se z těchto front odhlásit nebo v nich po odhlášení z aplikace zůstat?')
			],
		}]);

		this.footerEl.gwReplaceChildren([{
			nodeName: 'button',
			className: 'secondary',
			textContent: _('Zůstat ve frontách'),
			'on:click': ev => {
				this.promise.resolve('stay');
				this.destroy();
			},
		}, {
			nodeName: 'button',
			className: 'error',
			textContent: _('Odhlásit z front'),
			'on:click': ev => {
				this.promise.resolve('unsub');
				this.destroy();
			},
		}]);
	},

	'before:destroy'() {
		this.promise.resolve('cancel');
	},
});

// }}}

// Agent panel routes:

Application.logoutChecks.push(async function() {
	let exten = Application.session.user.extension;
	if (!exten) {
		return;
	}

	let my_queues = Office.QueueManager.getSubscribedQueues();
	if (my_queues.length > 0) {
		/*
		 * Show warning dialog if user is still subscribed to some queues
		 * on logout.
		 */
		let dlg = new Office.AgentSubscriptionWarningDialog({
			queues: my_queues.map(q => q.name),
		});

		let action = await dlg.promise;
		if (action == 'cancel') {
			return 'cancel';
		} else if (action == 'unsub') {
			await Office.QueueManager.leaveAllQueues(exten);
		}
	}
});

Application.watchMessages(function(msg) {
	if (msg.type == 'CALL_MISSED') {
		let contact = msg.caller || _('anonym');
		if (msg.contact) {
			contact = [msg.contact.name, msg.contact.company].filter(v => v).join(', ');
		}

		Application.desktopNotification({
			title: document.title,
			text: _('Zmeškaný hovor ve frontě {queue} od {contact}')
				.replace('{queue}', msg.queue)
				.replace('{contact}', contact),
			role: 'missed-call',
		});
	}
});

Application.addRoutes([{
	group: 'auth',
	module: 'agent',
	path: APP_BASE + 'agent',
	async handler({params}) {
		let c = Application.show({
			id: 'agent.main',
			xtype: 'Office.AgentPanel',
		});

		c.applyParams(params);
	}
}]);

Application.registerModule({
	id: 'agent',
	title: _('Agent panel'),
	tagline: _('Agentské pracoviště kontaktního centra'),
	icon: 'headphones',
	href: APP_BASE + 'agent',
});
